// This file is auto-generated by /developer/scripts/magecmd/buf.go:437.
// Do not edit.

import type {
  APIConstraints,
  APILimit,
  AbuseMark,
  ActionData,
  ActivityDefinition,
  ActivityDependency,
  ActivityDependencyTemplate,
  ActivityError,
  ActivityResult,
  AggregationBucket,
  AggregationResult,
  AnalysisActivityInput,
  AnalysisActivityInput_AnalysisOptions,
  AnalysisActivityInput_Context,
  AnalysisActivityInput_ReferenceMaterial,
  AnalysisActivityInput_ReferenceMaterial_Access,
  AnalysisActivityInput_ReferenceMaterial_ContentSample,
  AnalysisActivityInput_ReferenceMaterial_Relevance,
  AnalysisActivityInput_ReferenceMaterial_Source,
  AnalysisActivityInput_ReferenceRelationship,
  AnalysisActivityOutput,
  AnalysisActivityOutput_AlternativeIntent,
  AnalysisActivityOutput_Entity,
  AnalysisActivityOutput_LanguageInfo,
  AnalysisActivityOutput_RequestProperties,
  AnalysisActivityOutput_Requirement,
  AnalysisActivityOutput_ResponseCharacteristics,
  AnalysisActivityOutput_TemporalInfo,
  AnalysisActivityOutput_TemporalInfo_TimePeriod,
  AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship,
  AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration,
  AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange,
  AnalysisActivityResult,
  AnalysisState,
  ApiError,
  AppAppearancePreference,
  AppPreferences,
  ArchiveArtifactRequest,
  ArchiveArtifactResponse,
  Artifact,
  ArtifactClassification,
  ArtifactContent,
  ArtifactContentMetadata,
  ArtifactFilters,
  ArtifactGenerateToolInput,
  ArtifactGenerationInput,
  ArtifactGenerationOutput,
  ArtifactGenerationRequirements,
  ArtifactGenerationResult,
  ArtifactGenerationState,
  ArtifactResource,
  ArtifactReviseToolInput,
  ArtifactRevisionInput,
  ArtifactRevisionOutput,
  ArtifactRevisionRequirements,
  ArtifactRevisionResult,
  ArtifactRevisionState,
  ArtifactSearchResult,
  ArtifactSource,
  ArtifactSummary,
  ArtifactUsageStats,
  ArtifactVersion,
  ArtifactWithActions,
  Asset,
  AssetFilters,
  AssetJobStatus,
  AssetProcessingProgress,
  AssetProcessingSpec,
  AssetProcessingStatus,
  AssetProcessingStatusWithActions,
  AssetWithActions,
  AssetWithLabels,
  AssociateLabelRequest,
  AssociateLabelResponse,
  AuditMetadata,
  AuthenticatedInternalUser,
  AuthenticatedUser,
  AuthenticationError,
  AvailabilityConstraints,
  AvailabilityControl,
  AvailableRealm,
  AvailableRealmWithNames,
  BatchConstraints,
  BatchLimit,
  BlockquoteAttrs,
  BulkArtifactUpdate,
  BulkAssociateLabelsRequest,
  BulkAssociateLabelsResponse,
  BulkDeleteArtifactsRequest,
  BulkDeleteArtifactsResponse,
  BulkDisassociateLabelsRequest,
  BulkDisassociateLabelsResponse,
  BulkResourceTarget,
  BulkUpdateArtifactsRequest,
  BulkUpdateArtifactsResponse,
  ChangeComparison,
  ChangeImpactAssessment,
  ChangeRequirements,
  ChangeStats,
  ChatRequest,
  ChatResponse,
  ChatWorkflowInput,
  CheckPermissionRequest,
  CheckPermissionResponse,
  CheckRequest,
  CheckResponse,
  ChunkInfo,
  CitationFormats,
  CodeAttrs,
  CodeBlockAttrs,
  CompareArtifactVersionsRequest,
  CompareArtifactVersionsResponse,
  ComparisonOptions,
  CompleteAssetProcessingRequest,
  CompleteAssetProcessingResponse,
  CompleteAssetUploadRequest,
  CompleteAssetUploadResponse,
  ComplianceConstraints,
  ComplianceControl,
  ConceptData,
  Condition,
  ConditionalDependency,
  ConfidenceScoreCondition,
  ConflictResolution,
  ContentAnalysisMetadata,
  ContentConstraints,
  ContentLimit,
  ContentRequirements,
  ContentSection,
  ContentSentiment,
  ContentSnapshot,
  ContextScope,
  ConversationContext,
  ConversationContext_Message,
  ConversationContext_UserPreferences,
  ConversationRequest,
  ConversationResponse,
  ConvertArtifactFormatRequest,
  ConvertArtifactFormatResponse,
  CreateArtifactRequest,
  CreateArtifactResponse,
  CreateArtifactVersionRequest,
  CreateArtifactVersionResponse,
  CreateAssetRequest,
  CreateAssetResponse,
  CreateLabelRequest,
  CreateLabelResponse,
  CreateOrganizationRequest,
  CreateOrganizationResponse,
  CreateProjectRequest,
  CreateProjectResponse,
  CreateTenantRequest,
  CreateTenantResponse,
  CreateViewRequest,
  CreateViewResponse,
  CreateWorkspaceRequest,
  CreateWorkspaceResponse,
  DataSecurityClassificationCondition,
  DeleteArtifactRequest,
  DeleteArtifactResponse,
  DeleteAssetRequest,
  DeleteAssetResponse,
  DeleteLabelRequest,
  DeleteLabelResponse,
  DeleteViewRequest,
  DeleteViewResponse,
  DisassociateLabelRequest,
  DisassociateLabelResponse,
  DocAttrs,
  EmAttrs,
  EmailAddress,
  Embedding,
  EmotionalTone,
  EncryptionMetadata,
  EnrichedScope,
  Entitlement,
  EstimatedResourceRequirements,
  ExecuteViewRequest,
  ExecuteViewResponse,
  ExecutionActivityInput,
  ExecutionContext,
  ExecutionStep,
  ExecutionStepOutput,
  ExecutionStepResult,
  ExecutionStep_StepOptions,
  ExportArtifactRequest,
  ExportArtifactResponse,
  ExportOptions,
  ExternalIdentifier,
  FileAttachment,
  FileData,
  FloatLimit,
  ForkArtifactRequest,
  ForkArtifactResponse,
  FormatRequirements,
  GenerationContext,
  GenerationStatistics,
  GenerationSummary,
  GetArtifactContentHistoryRequest,
  GetArtifactContentHistoryResponse,
  GetArtifactContentRequest,
  GetArtifactContentResponse,
  GetArtifactRequest,
  GetArtifactResponse,
  GetArtifactStatsRequest,
  GetArtifactStatsResponse,
  GetArtifactVersionRequest,
  GetArtifactVersionResponse,
  GetAssetJobStatusRequest,
  GetAssetJobStatusResponse,
  GetAssetRequest,
  GetAssetResponse,
  GetAssetsRequest,
  GetAssetsResponse,
  GetBulkAssetJobStatusRequest,
  GetBulkAssetJobStatusResponse,
  GetLabelRequest,
  GetLabelResourcesRequest,
  GetLabelResourcesResponse,
  GetLabelResponse,
  GetPinnedViewsRequest,
  GetPinnedViewsResponse,
  GetRealmRequest,
  GetRealmResponse,
  GetRelatedArtifactsRequest,
  GetRelatedArtifactsResponse,
  GetResourceLabelsRequest,
  GetResourceLabelsResponse,
  GetSelfRequest,
  GetSelfResponse,
  GetUserRequest,
  GetUserResponse,
  GetViewRequest,
  GetViewResponse,
  GrantPermissionRequest,
  GrantPermissionResponse,
  GrantRealmPermissionsRequest,
  GrantRealmPermissionsResponse,
  HandleProcessingErrorRequest,
  HandleProcessingErrorResponse,
  HeadingAttrs,
  HealthCheckStats,
  HighlightAttrs,
  HorizontalRuleAttrs,
  ImageAttrs,
  ImportInfo,
  IngestConstraints,
  IngestLimit,
  IntegerLimit,
  InvalidRequestError,
  LLMTelemetry,
  Label,
  LabelAssociation,
  LabelData,
  LabelSummary,
  LabelWithActions,
  LimitPeriod,
  LineRange,
  LinkAttrs,
  ListAllRealmsRequest,
  ListAllRealmsResponse,
  ListArtifactVersionsRequest,
  ListArtifactVersionsResponse,
  ListArtifactsRequest,
  ListArtifactsResponse,
  ListAssetsRequest,
  ListAssetsResponse,
  ListAttrs,
  ListAvailableRealmsRequest,
  ListAvailableRealmsResponse,
  ListItemAttrs,
  ListLabelsRequest,
  ListLabelsResponse,
  ListRealmUserPermissionsRequest,
  ListRealmUserPermissionsResponse,
  ListUserRealmPermissionsRequest,
  ListUserRealmPermissionsResponse,
  ListUsersRequest,
  ListUsersResponse,
  ListViewsRequest,
  ListViewsResponse,
  Mark,
  MemoryObservationSummary,
  MemoryUpdate,
  MemoryUpdate_ObservationContent,
  MemoryUpdate_ObservationContent_Conflict,
  MentionData,
  MentionNodeAttrs,
  MergeArtifactRequest,
  MergeArtifactResponse,
  MergeConflict,
  MergeInfo,
  MessageErrorData,
  MessageLimitData,
  MessagePingData,
  MessageWarningData,
  ModelAccessSettings,
  ModelAccessSystemPreference,
  MultiFormatContent,
  Node,
  NotFoundError,
  OperationContext,
  OriginatingRequest,
  OverloadedError,
  ParagraphAttrs,
  Permission,
  PermissionError,
  PinViewRequest,
  PinViewResponse,
  Preferences,
  PreviewViewRequest,
  PreviewViewResponse,
  ProcessingMetadata,
  ProcessingResult,
  ProcessingStepUpdate,
  ProcessingTimeMetrics,
  Prompt,
  PublicationRequirements,
  PublishArtifactRequest,
  PublishArtifactResponse,
  PublishingInfo,
  QualityAssessment,
  QualityComparison,
  QualityImprovement,
  QualityIssue,
  QualityMetrics,
  QualityRequirements,
  QuotaConstraints,
  QuotaLimit,
  RateConstraints,
  RateLimit,
  RateLimitError,
  ReadabilityMetrics,
  Realm,
  RealmPermission,
  RealmPermissionGrant,
  RealmUserPermissions,
  RealmWithNames,
  RecordArtifactViewRequest,
  RecordArtifactViewResponse,
  RecordedMessage,
  Recording,
  ReferenceMaterial,
  ReferenceMaterial_Access,
  ReferenceMaterial_ContentSample,
  ReferenceMaterial_Relevance,
  ReferenceMaterial_Source,
  ReferenceRelationship,
  RelatedArtifact,
  RelationshipData,
  ReprocessAssetRequest,
  ReprocessAssetResponse,
  RequestTooLargeError,
  ResourceAccess,
  ResourceAttributeCondition,
  ResourceAttributeKeyPair,
  ResourceConstraints,
  ResourceLimit,
  ResourceLimits,
  ResourceReference,
  RestoreArtifactRequest,
  RestoreArtifactResponse,
  RetryStrategy,
  RevisionStatistics,
  RevisionSummary,
  RevokeRealmPermissionsRequest,
  RevokeRealmPermissionsResponse,
  RichText,
  SEOMetadata,
  Scope,
  ScopeView,
  SearchArtifactsRequest,
  SearchArtifactsResponse,
  SearchAssetsRequest,
  SearchAssetsResponse,
  SearchFacet,
  SearchFacetValue,
  SearchHighlight,
  SearchMetadata,
  SearchOptions,
  SearchResult,
  SearchUsersRequest,
  SearchUsersResponse,
  ServiceStatus,
  Settings,
  Share,
  SizeChange,
  SourceAccess,
  SourceAttribution,
  SourceAuthor,
  SourceCitation,
  SourceExcerpt,
  SourceMaterial,
  SourceMetadata,
  SourceQuality,
  SourceUsage,
  StatsPeriod,
  StepError,
  StrategyActivityInput,
  StrategyActivityInput_StrategyOptions,
  StrategyActivityOutput,
  StrategyActivityOutput_StrategyMetadata,
  StrategyActivityResult,
  StrategyState,
  StreamPlaybackRequest,
  StreamPlaybackResponse,
  StreamRequest,
  StreamResponse,
  StrikeAttrs,
  StrongAttrs,
  SubscriptAttrs,
  SuperscriptAttrs,
  SyncRequest,
  SyncResponse,
  SystemPreference,
  TableAttrs,
  TableCellAttrs,
  TextAttachment,
  TimeConstraints,
  TimeLimit,
  ToolConfig,
  ToolError,
  ToolExample,
  ToolExecutionError,
  ToolParameter,
  ToolParameters,
  ToolProperty,
  ToolSchema,
  ToolSchemaShort,
  TriageActivityInput,
  TriageActivityInput_TriageOptions,
  TriageActivityOutput,
  TriageActivityOutput_ClarificationRequest,
  TriageActivityOutput_DirectResponse,
  TriageActivityResult,
  TriageState,
  UnpinViewRequest,
  UnpinViewResponse,
  UnpublishArtifactRequest,
  UnpublishArtifactResponse,
  UpdateArtifactContentRequest,
  UpdateArtifactContentResponse,
  UpdateArtifactRequest,
  UpdateArtifactResponse,
  UpdateAssetRequest,
  UpdateAssetResponse,
  UpdateAssetStatusRequest,
  UpdateAssetStatusResponse,
  UpdateLabelRequest,
  UpdateLabelResponse,
  UpdateLastAccessedRequest,
  UpdateLastAccessedResponse,
  UpdateProcessingProgressRequest,
  UpdateProcessingProgressResponse,
  UpdateRealmNamesRequest,
  UpdateRealmNamesResponse,
  UpdateSelfRequest,
  UpdateSelfResponse,
  UpdateViewRequest,
  UpdateViewResponse,
  UploadAssetRequest,
  UploadAssetResponse,
  UploadProgress,
  User,
  UserAttribution,
  UserData,
  UserInternal,
  UserKbSearchInput,
  UserKbSearchOutput,
  UserKbSearchResult,
  UserLearning,
  UserLearning_LearningContent,
  UserLearning_LearningMetadata,
  UserMemory,
  UserMemory_MemoryContent,
  UserMemory_MemoryMetadata,
  UserWithActions,
  ValidationRequirements,
  VariableNodeV1Attrs,
  VersionApproval,
  VersionApprovalRecord,
  VersionChange,
  VersionComparison,
  VersionDifference,
  VersionQualityMetrics,
  VersionSizeInfo,
  View,
  ViewFilter,
  ViewResultItem,
  ViewResults,
  ViewSummary,
  ViewWithActions,
  WebSearchToolInput,
  WebSearchToolOutput,
  WorkflowConstraints,
  WorkflowContext,
  WorkflowError,
  WorkflowLimit,
} from "./gen";

export const MessageKind = {
  APIConstraints: "entitlements.v3.APIConstraints",
  APILimit: "entitlements.v3.APILimit",
  AbuseMark: "users.v3.AbuseMark",
  ActionData: "chat.v3.ActionData",
  ActivityDefinition: "agent.v3.workflow.v1.ActivityDefinition",
  ActivityDependency: "agent.v3.workflow.v1.ActivityDependency",
  ActivityDependencyTemplate: "agent.v3.workflow.v1.ActivityDependencyTemplate",
  ActivityError: "agent.v3.ActivityError",
  ActivityResult: "agent.v3.workflow.v1.ActivityResult",
  AggregationBucket: "artifacts.v3.AggregationBucket",
  AggregationResult: "artifacts.v3.AggregationResult",
  AnalysisActivityInput: "agent.v3.activities.analysis.v1.AnalysisActivityInput",
  AnalysisActivityInput_AnalysisOptions: "agent.v3.activities.analysis.v1.AnalysisActivityInput.AnalysisOptions",
  AnalysisActivityInput_Context: "agent.v3.activities.analysis.v1.AnalysisActivityInput.Context",
  AnalysisActivityInput_ReferenceMaterial: "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceMaterial",
  AnalysisActivityInput_ReferenceMaterial_Access:
    "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceMaterial.Access",
  AnalysisActivityInput_ReferenceMaterial_ContentSample:
    "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceMaterial.ContentSample",
  AnalysisActivityInput_ReferenceMaterial_Relevance:
    "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceMaterial.Relevance",
  AnalysisActivityInput_ReferenceMaterial_Source:
    "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceMaterial.Source",
  AnalysisActivityInput_ReferenceRelationship:
    "agent.v3.activities.analysis.v1.AnalysisActivityInput.ReferenceRelationship",
  AnalysisActivityOutput: "agent.v3.activities.analysis.v1.AnalysisActivityOutput",
  AnalysisActivityOutput_AlternativeIntent: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.AlternativeIntent",
  AnalysisActivityOutput_Entity: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.Entity",
  AnalysisActivityOutput_LanguageInfo: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.LanguageInfo",
  AnalysisActivityOutput_RequestProperties: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.RequestProperties",
  AnalysisActivityOutput_Requirement: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.Requirement",
  AnalysisActivityOutput_ResponseCharacteristics:
    "agent.v3.activities.analysis.v1.AnalysisActivityOutput.ResponseCharacteristics",
  AnalysisActivityOutput_TemporalInfo: "agent.v3.activities.analysis.v1.AnalysisActivityOutput.TemporalInfo",
  AnalysisActivityOutput_TemporalInfo_TimePeriod:
    "agent.v3.activities.analysis.v1.AnalysisActivityOutput.TemporalInfo.TimePeriod",
  AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship:
    "agent.v3.activities.analysis.v1.AnalysisActivityOutput.TemporalInfo.TimePeriodRelationship",
  AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration:
    "agent.v3.activities.analysis.v1.AnalysisActivityOutput.TemporalInfo.TimePeriod.Duration",
  AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange:
    "agent.v3.activities.analysis.v1.AnalysisActivityOutput.TemporalInfo.TimePeriod.TimeRange",
  AnalysisActivityResult: "agent.v3.activities.analysis.v1.AnalysisActivityResult",
  AnalysisState: "agent.v3.activities.analysis.v1.AnalysisState",
  ApiError: "chat.v3.ApiError",
  AppAppearancePreference: "preferences.v3.AppAppearancePreference",
  AppPreferences: "preferences.v3.AppPreferences",
  ArchiveArtifactRequest: "artifacts.v3.ArchiveArtifactRequest",
  ArchiveArtifactResponse: "artifacts.v3.ArchiveArtifactResponse",
  Artifact: "artifacts.v3.Artifact",
  ArtifactClassification: "artifacts.v3.ArtifactClassification",
  ArtifactContent: "artifacts.v3.ArtifactContent",
  ArtifactContentMetadata: "artifacts.v3.ArtifactContentMetadata",
  ArtifactFilters: "views.v3.ArtifactFilters",
  ArtifactGenerateToolInput: "agent.v3.activities.artifact_editor.v1.ArtifactGenerateToolInput",
  ArtifactGenerationInput: "agent.v3.activities.artifact_editor.v1.ArtifactGenerationInput",
  ArtifactGenerationOutput: "agent.v3.activities.artifact_editor.v1.ArtifactGenerationOutput",
  ArtifactGenerationRequirements: "agent.v3.activities.artifact_editor.v1.ArtifactGenerationRequirements",
  ArtifactGenerationResult: "agent.v3.activities.artifact_editor.v1.ArtifactGenerationResult",
  ArtifactGenerationState: "agent.v3.activities.artifact_editor.v1.ArtifactGenerationState",
  ArtifactResource: "artifacts.v3.ArtifactResource",
  ArtifactReviseToolInput: "agent.v3.activities.artifact_editor.v1.ArtifactReviseToolInput",
  ArtifactRevisionInput: "agent.v3.activities.artifact_editor.v1.ArtifactRevisionInput",
  ArtifactRevisionOutput: "agent.v3.activities.artifact_editor.v1.ArtifactRevisionOutput",
  ArtifactRevisionRequirements: "agent.v3.activities.artifact_editor.v1.ArtifactRevisionRequirements",
  ArtifactRevisionResult: "agent.v3.activities.artifact_editor.v1.ArtifactRevisionResult",
  ArtifactRevisionState: "agent.v3.activities.artifact_editor.v1.ArtifactRevisionState",
  ArtifactSearchResult: "artifacts.v3.ArtifactSearchResult",
  ArtifactSource: "artifacts.v3.ArtifactSource",
  ArtifactSummary: "artifacts.v3.ArtifactSummary",
  ArtifactUsageStats: "artifacts.v3.ArtifactUsageStats",
  ArtifactVersion: "artifacts.v3.ArtifactVersion",
  ArtifactWithActions: "artifacts.v3.ArtifactWithActions",
  Asset: "assets.v3.Asset",
  AssetFilters: "views.v3.AssetFilters",
  AssetJobStatus: "assets.v3.AssetJobStatus",
  AssetProcessingProgress: "fileproc.v3.AssetProcessingProgress",
  AssetProcessingSpec: "fileproc.v3.AssetProcessingSpec",
  AssetProcessingStatus: "fileproc.v3.AssetProcessingStatus",
  AssetProcessingStatusWithActions: "fileproc.v3.AssetProcessingStatusWithActions",
  AssetWithActions: "assets.v3.AssetWithActions",
  AssetWithLabels: "assets.v3.AssetWithLabels",
  AssociateLabelRequest: "labels.v3.AssociateLabelRequest",
  AssociateLabelResponse: "labels.v3.AssociateLabelResponse",
  AuditMetadata: "common.v3.AuditMetadata",
  AuthenticatedInternalUser: "auth.v3.AuthenticatedInternalUser",
  AuthenticatedUser: "auth.v3.AuthenticatedUser",
  AuthenticationError: "chat.v3.AuthenticationError",
  AvailabilityConstraints: "entitlements.v3.AvailabilityConstraints",
  AvailabilityControl: "entitlements.v3.AvailabilityControl",
  AvailableRealm: "realm.v3.AvailableRealm",
  AvailableRealmWithNames: "realm.v3.AvailableRealmWithNames",
  BatchConstraints: "entitlements.v3.BatchConstraints",
  BatchLimit: "entitlements.v3.BatchLimit",
  BlockquoteAttrs: "chat.v3.BlockquoteAttrs",
  BulkArtifactUpdate: "artifacts.v3.BulkArtifactUpdate",
  BulkAssociateLabelsRequest: "labels.v3.BulkAssociateLabelsRequest",
  BulkAssociateLabelsResponse: "labels.v3.BulkAssociateLabelsResponse",
  BulkDeleteArtifactsRequest: "artifacts.v3.BulkDeleteArtifactsRequest",
  BulkDeleteArtifactsResponse: "artifacts.v3.BulkDeleteArtifactsResponse",
  BulkDisassociateLabelsRequest: "labels.v3.BulkDisassociateLabelsRequest",
  BulkDisassociateLabelsResponse: "labels.v3.BulkDisassociateLabelsResponse",
  BulkResourceTarget: "labels.v3.BulkResourceTarget",
  BulkUpdateArtifactsRequest: "artifacts.v3.BulkUpdateArtifactsRequest",
  BulkUpdateArtifactsResponse: "artifacts.v3.BulkUpdateArtifactsResponse",
  ChangeComparison: "artifacts.v3.ChangeComparison",
  ChangeImpactAssessment: "agent.v3.activities.artifact_editor.v1.ChangeImpactAssessment",
  ChangeRequirements: "agent.v3.activities.artifact_editor.v1.ChangeRequirements",
  ChangeStats: "artifacts.v3.ChangeStats",
  ChatRequest: "chat.v3.ChatRequest",
  ChatResponse: "chat.v3.ChatResponse",
  ChatWorkflowInput: "agent.v3.ChatWorkflowInput",
  CheckPermissionRequest: "authz.v3.CheckPermissionRequest",
  CheckPermissionResponse: "authz.v3.CheckPermissionResponse",
  CheckRequest: "status.v3.CheckRequest",
  CheckResponse: "status.v3.CheckResponse",
  ChunkInfo: "assets.v3.ChunkInfo",
  CitationFormats: "artifacts.v3.CitationFormats",
  CodeAttrs: "chat.v3.CodeAttrs",
  CodeBlockAttrs: "chat.v3.CodeBlockAttrs",
  CompareArtifactVersionsRequest: "artifacts.v3.CompareArtifactVersionsRequest",
  CompareArtifactVersionsResponse: "artifacts.v3.CompareArtifactVersionsResponse",
  ComparisonOptions: "artifacts.v3.ComparisonOptions",
  CompleteAssetProcessingRequest: "fileproc.v3.CompleteAssetProcessingRequest",
  CompleteAssetProcessingResponse: "fileproc.v3.CompleteAssetProcessingResponse",
  CompleteAssetUploadRequest: "assets.v3.CompleteAssetUploadRequest",
  CompleteAssetUploadResponse: "assets.v3.CompleteAssetUploadResponse",
  ComplianceConstraints: "entitlements.v3.ComplianceConstraints",
  ComplianceControl: "entitlements.v3.ComplianceControl",
  ConceptData: "chat.v3.ConceptData",
  Condition: "authz.v3.Condition",
  ConditionalDependency: "agent.v3.workflow.v1.ConditionalDependency",
  ConfidenceScoreCondition: "authz.v3.ConfidenceScoreCondition",
  ConflictResolution: "artifacts.v3.ConflictResolution",
  ContentAnalysisMetadata: "artifacts.v3.ContentAnalysisMetadata",
  ContentConstraints: "entitlements.v3.ContentConstraints",
  ContentLimit: "entitlements.v3.ContentLimit",
  ContentRequirements: "agent.v3.activities.artifact_editor.v1.ContentRequirements",
  ContentSection: "artifacts.v3.ContentSection",
  ContentSentiment: "artifacts.v3.ContentSentiment",
  ContentSnapshot: "artifacts.v3.ContentSnapshot",
  ContextScope: "agent.v3.workflow.v1.ContextScope",
  ConversationContext: "agent.v3.context.v1.ConversationContext",
  ConversationContext_Message: "agent.v3.context.v1.ConversationContext.Message",
  ConversationContext_UserPreferences: "agent.v3.context.v1.ConversationContext.UserPreferences",
  ConversationRequest: "chat.v3.ConversationRequest",
  ConversationResponse: "chat.v3.ConversationResponse",
  ConvertArtifactFormatRequest: "artifacts.v3.ConvertArtifactFormatRequest",
  ConvertArtifactFormatResponse: "artifacts.v3.ConvertArtifactFormatResponse",
  CreateArtifactRequest: "artifacts.v3.CreateArtifactRequest",
  CreateArtifactResponse: "artifacts.v3.CreateArtifactResponse",
  CreateArtifactVersionRequest: "artifacts.v3.CreateArtifactVersionRequest",
  CreateArtifactVersionResponse: "artifacts.v3.CreateArtifactVersionResponse",
  CreateAssetRequest: "assets.v3.CreateAssetRequest",
  CreateAssetResponse: "assets.v3.CreateAssetResponse",
  CreateLabelRequest: "labels.v3.CreateLabelRequest",
  CreateLabelResponse: "labels.v3.CreateLabelResponse",
  CreateOrganizationRequest: "realm.v3.CreateOrganizationRequest",
  CreateOrganizationResponse: "realm.v3.CreateOrganizationResponse",
  CreateProjectRequest: "realm.v3.CreateProjectRequest",
  CreateProjectResponse: "realm.v3.CreateProjectResponse",
  CreateTenantRequest: "realm.v3.CreateTenantRequest",
  CreateTenantResponse: "realm.v3.CreateTenantResponse",
  CreateViewRequest: "views.v3.CreateViewRequest",
  CreateViewResponse: "views.v3.CreateViewResponse",
  CreateWorkspaceRequest: "realm.v3.CreateWorkspaceRequest",
  CreateWorkspaceResponse: "realm.v3.CreateWorkspaceResponse",
  DataSecurityClassificationCondition: "authz.v3.DataSecurityClassificationCondition",
  DeleteArtifactRequest: "artifacts.v3.DeleteArtifactRequest",
  DeleteArtifactResponse: "artifacts.v3.DeleteArtifactResponse",
  DeleteAssetRequest: "assets.v3.DeleteAssetRequest",
  DeleteAssetResponse: "assets.v3.DeleteAssetResponse",
  DeleteLabelRequest: "labels.v3.DeleteLabelRequest",
  DeleteLabelResponse: "labels.v3.DeleteLabelResponse",
  DeleteViewRequest: "views.v3.DeleteViewRequest",
  DeleteViewResponse: "views.v3.DeleteViewResponse",
  DisassociateLabelRequest: "labels.v3.DisassociateLabelRequest",
  DisassociateLabelResponse: "labels.v3.DisassociateLabelResponse",
  DocAttrs: "chat.v3.DocAttrs",
  EmAttrs: "chat.v3.EmAttrs",
  EmailAddress: "users.v3.EmailAddress",
  Embedding: "assets.v3.Embedding",
  EmotionalTone: "artifacts.v3.EmotionalTone",
  EncryptionMetadata: "agent.v3.EncryptionMetadata",
  EnrichedScope: "query.v3.EnrichedScope",
  Entitlement: "entitlements.v3.Entitlement",
  EstimatedResourceRequirements: "agent.v3.workflow.v1.EstimatedResourceRequirements",
  ExecuteViewRequest: "views.v3.ExecuteViewRequest",
  ExecuteViewResponse: "views.v3.ExecuteViewResponse",
  ExecutionActivityInput: "agent.v3.activities.execution.v1.ExecutionActivityInput",
  ExecutionContext: "agent.v3.activities.execution.v1.ExecutionContext",
  ExecutionStep: "agent.v3.activities.execution.v1.ExecutionStep",
  ExecutionStepOutput: "agent.v3.activities.execution.v1.ExecutionStepOutput",
  ExecutionStepResult: "agent.v3.activities.execution.v1.ExecutionStepResult",
  ExecutionStep_StepOptions: "agent.v3.activities.execution.v1.ExecutionStep.StepOptions",
  ExportArtifactRequest: "artifacts.v3.ExportArtifactRequest",
  ExportArtifactResponse: "artifacts.v3.ExportArtifactResponse",
  ExportOptions: "artifacts.v3.ExportOptions",
  ExternalIdentifier: "auth.v3.ExternalIdentifier",
  FileAttachment: "query.v3.FileAttachment",
  FileData: "chat.v3.FileData",
  FloatLimit: "entitlements.v3.FloatLimit",
  ForkArtifactRequest: "artifacts.v3.ForkArtifactRequest",
  ForkArtifactResponse: "artifacts.v3.ForkArtifactResponse",
  FormatRequirements: "agent.v3.activities.artifact_editor.v1.FormatRequirements",
  GenerationContext: "artifacts.v3.GenerationContext",
  GenerationStatistics: "agent.v3.activities.artifact_editor.v1.GenerationStatistics",
  GenerationSummary: "agent.v3.activities.artifact_editor.v1.GenerationSummary",
  GetArtifactContentHistoryRequest: "artifacts.v3.GetArtifactContentHistoryRequest",
  GetArtifactContentHistoryResponse: "artifacts.v3.GetArtifactContentHistoryResponse",
  GetArtifactContentRequest: "artifacts.v3.GetArtifactContentRequest",
  GetArtifactContentResponse: "artifacts.v3.GetArtifactContentResponse",
  GetArtifactRequest: "artifacts.v3.GetArtifactRequest",
  GetArtifactResponse: "artifacts.v3.GetArtifactResponse",
  GetArtifactStatsRequest: "artifacts.v3.GetArtifactStatsRequest",
  GetArtifactStatsResponse: "artifacts.v3.GetArtifactStatsResponse",
  GetArtifactVersionRequest: "artifacts.v3.GetArtifactVersionRequest",
  GetArtifactVersionResponse: "artifacts.v3.GetArtifactVersionResponse",
  GetAssetJobStatusRequest: "assets.v3.GetAssetJobStatusRequest",
  GetAssetJobStatusResponse: "assets.v3.GetAssetJobStatusResponse",
  GetAssetRequest: "assets.v3.GetAssetRequest",
  GetAssetResponse: "assets.v3.GetAssetResponse",
  GetAssetsRequest: "assets.v3.GetAssetsRequest",
  GetAssetsResponse: "assets.v3.GetAssetsResponse",
  GetBulkAssetJobStatusRequest: "assets.v3.GetBulkAssetJobStatusRequest",
  GetBulkAssetJobStatusResponse: "assets.v3.GetBulkAssetJobStatusResponse",
  GetLabelRequest: "labels.v3.GetLabelRequest",
  GetLabelResourcesRequest: "labels.v3.GetLabelResourcesRequest",
  GetLabelResourcesResponse: "labels.v3.GetLabelResourcesResponse",
  GetLabelResponse: "labels.v3.GetLabelResponse",
  GetPinnedViewsRequest: "views.v3.GetPinnedViewsRequest",
  GetPinnedViewsResponse: "views.v3.GetPinnedViewsResponse",
  GetRealmRequest: "realm.v3.GetRealmRequest",
  GetRealmResponse: "realm.v3.GetRealmResponse",
  GetRelatedArtifactsRequest: "artifacts.v3.GetRelatedArtifactsRequest",
  GetRelatedArtifactsResponse: "artifacts.v3.GetRelatedArtifactsResponse",
  GetResourceLabelsRequest: "labels.v3.GetResourceLabelsRequest",
  GetResourceLabelsResponse: "labels.v3.GetResourceLabelsResponse",
  GetSelfRequest: "users.v3.GetSelfRequest",
  GetSelfResponse: "users.v3.GetSelfResponse",
  GetUserRequest: "users.v3.GetUserRequest",
  GetUserResponse: "users.v3.GetUserResponse",
  GetViewRequest: "views.v3.GetViewRequest",
  GetViewResponse: "views.v3.GetViewResponse",
  GrantPermissionRequest: "authz.v3.GrantPermissionRequest",
  GrantPermissionResponse: "authz.v3.GrantPermissionResponse",
  GrantRealmPermissionsRequest: "realm.v3.GrantRealmPermissionsRequest",
  GrantRealmPermissionsResponse: "realm.v3.GrantRealmPermissionsResponse",
  HandleProcessingErrorRequest: "fileproc.v3.HandleProcessingErrorRequest",
  HandleProcessingErrorResponse: "fileproc.v3.HandleProcessingErrorResponse",
  HeadingAttrs: "chat.v3.HeadingAttrs",
  HealthCheckStats: "status.v3.HealthCheckStats",
  HighlightAttrs: "chat.v3.HighlightAttrs",
  HorizontalRuleAttrs: "chat.v3.HorizontalRuleAttrs",
  ImageAttrs: "chat.v3.ImageAttrs",
  ImportInfo: "artifacts.v3.ImportInfo",
  IngestConstraints: "entitlements.v3.IngestConstraints",
  IngestLimit: "entitlements.v3.IngestLimit",
  IntegerLimit: "entitlements.v3.IntegerLimit",
  InvalidRequestError: "chat.v3.InvalidRequestError",
  LLMTelemetry: "agent.v3.telemetry.v1.LLMTelemetry",
  Label: "labels.v3.Label",
  LabelAssociation: "labels.v3.LabelAssociation",
  LabelData: "chat.v3.LabelData",
  LabelSummary: "labels.v3.LabelSummary",
  LabelWithActions: "labels.v3.LabelWithActions",
  LimitPeriod: "entitlements.v3.LimitPeriod",
  LineRange: "artifacts.v3.LineRange",
  LinkAttrs: "chat.v3.LinkAttrs",
  ListAllRealmsRequest: "realm.v3.ListAllRealmsRequest",
  ListAllRealmsResponse: "realm.v3.ListAllRealmsResponse",
  ListArtifactVersionsRequest: "artifacts.v3.ListArtifactVersionsRequest",
  ListArtifactVersionsResponse: "artifacts.v3.ListArtifactVersionsResponse",
  ListArtifactsRequest: "artifacts.v3.ListArtifactsRequest",
  ListArtifactsResponse: "artifacts.v3.ListArtifactsResponse",
  ListAssetsRequest: "assets.v3.ListAssetsRequest",
  ListAssetsResponse: "assets.v3.ListAssetsResponse",
  ListAttrs: "chat.v3.ListAttrs",
  ListAvailableRealmsRequest: "realm.v3.ListAvailableRealmsRequest",
  ListAvailableRealmsResponse: "realm.v3.ListAvailableRealmsResponse",
  ListItemAttrs: "chat.v3.ListItemAttrs",
  ListLabelsRequest: "labels.v3.ListLabelsRequest",
  ListLabelsResponse: "labels.v3.ListLabelsResponse",
  ListRealmUserPermissionsRequest: "realm.v3.ListRealmUserPermissionsRequest",
  ListRealmUserPermissionsResponse: "realm.v3.ListRealmUserPermissionsResponse",
  ListUserRealmPermissionsRequest: "realm.v3.ListUserRealmPermissionsRequest",
  ListUserRealmPermissionsResponse: "realm.v3.ListUserRealmPermissionsResponse",
  ListUsersRequest: "users.v3.ListUsersRequest",
  ListUsersResponse: "users.v3.ListUsersResponse",
  ListViewsRequest: "views.v3.ListViewsRequest",
  ListViewsResponse: "views.v3.ListViewsResponse",
  Mark: "chat.v3.Mark",
  MemoryObservationSummary: "agent.v3.user_memory.v1.MemoryObservationSummary",
  MemoryUpdate: "agent.v3.user_memory.v1.MemoryUpdate",
  MemoryUpdate_ObservationContent: "agent.v3.user_memory.v1.MemoryUpdate.ObservationContent",
  MemoryUpdate_ObservationContent_Conflict: "agent.v3.user_memory.v1.MemoryUpdate.ObservationContent.Conflict",
  MentionData: "chat.v3.MentionData",
  MentionNodeAttrs: "chat.v3.MentionNodeAttrs",
  MergeArtifactRequest: "artifacts.v3.MergeArtifactRequest",
  MergeArtifactResponse: "artifacts.v3.MergeArtifactResponse",
  MergeConflict: "artifacts.v3.MergeConflict",
  MergeInfo: "artifacts.v3.MergeInfo",
  MessageErrorData: "chat.v3.MessageErrorData",
  MessageLimitData: "chat.v3.MessageLimitData",
  MessagePingData: "chat.v3.MessagePingData",
  MessageWarningData: "chat.v3.MessageWarningData",
  ModelAccessSettings: "settings.v3.ModelAccessSettings",
  ModelAccessSystemPreference: "preferences.v3.ModelAccessSystemPreference",
  MultiFormatContent: "artifacts.v3.MultiFormatContent",
  Node: "chat.v3.Node",
  NotFoundError: "chat.v3.NotFoundError",
  OperationContext: "agent.v3.activities.execution.v1.OperationContext",
  OriginatingRequest: "agent.v3.workflow.v1.OriginatingRequest",
  OverloadedError: "chat.v3.OverloadedError",
  ParagraphAttrs: "chat.v3.ParagraphAttrs",
  Permission: "authz.v3.Permission",
  PermissionError: "chat.v3.PermissionError",
  PinViewRequest: "views.v3.PinViewRequest",
  PinViewResponse: "views.v3.PinViewResponse",
  Preferences: "preferences.v3.Preferences",
  PreviewViewRequest: "views.v3.PreviewViewRequest",
  PreviewViewResponse: "views.v3.PreviewViewResponse",
  ProcessingMetadata: "assets.v3.ProcessingMetadata",
  ProcessingResult: "fileproc.v3.ProcessingResult",
  ProcessingStepUpdate: "fileproc.v3.ProcessingStepUpdate",
  ProcessingTimeMetrics: "agent.v3.ProcessingTimeMetrics",
  Prompt: "chat.v3.Prompt",
  PublicationRequirements: "agent.v3.activities.artifact_editor.v1.PublicationRequirements",
  PublishArtifactRequest: "artifacts.v3.PublishArtifactRequest",
  PublishArtifactResponse: "artifacts.v3.PublishArtifactResponse",
  PublishingInfo: "artifacts.v3.PublishingInfo",
  QualityAssessment: "agent.v3.activities.artifact_editor.v1.QualityAssessment",
  QualityComparison: "agent.v3.activities.artifact_editor.v1.QualityComparison",
  QualityImprovement: "agent.v3.activities.artifact_editor.v1.QualityImprovement",
  QualityIssue: "artifacts.v3.QualityIssue",
  QualityMetrics: "artifacts.v3.QualityMetrics",
  QualityRequirements: "agent.v3.activities.artifact_editor.v1.QualityRequirements",
  QuotaConstraints: "entitlements.v3.QuotaConstraints",
  QuotaLimit: "entitlements.v3.QuotaLimit",
  RateConstraints: "entitlements.v3.RateConstraints",
  RateLimit: "entitlements.v3.RateLimit",
  RateLimitError: "chat.v3.RateLimitError",
  ReadabilityMetrics: "artifacts.v3.ReadabilityMetrics",
  Realm: "realm.v3.Realm",
  RealmPermission: "realm.v3.RealmPermission",
  RealmPermissionGrant: "realm.v3.RealmPermissionGrant",
  RealmUserPermissions: "realm.v3.RealmUserPermissions",
  RealmWithNames: "realm.v3.RealmWithNames",
  RecordArtifactViewRequest: "artifacts.v3.RecordArtifactViewRequest",
  RecordArtifactViewResponse: "artifacts.v3.RecordArtifactViewResponse",
  RecordedMessage: "chat.v3.RecordedMessage",
  Recording: "chat.v3.Recording",
  ReferenceMaterial: "agent.v3.context.v1.ReferenceMaterial",
  ReferenceMaterial_Access: "agent.v3.context.v1.ReferenceMaterial.Access",
  ReferenceMaterial_ContentSample: "agent.v3.context.v1.ReferenceMaterial.ContentSample",
  ReferenceMaterial_Relevance: "agent.v3.context.v1.ReferenceMaterial.Relevance",
  ReferenceMaterial_Source: "agent.v3.context.v1.ReferenceMaterial.Source",
  ReferenceRelationship: "agent.v3.context.v1.ReferenceRelationship",
  RelatedArtifact: "artifacts.v3.RelatedArtifact",
  RelationshipData: "chat.v3.RelationshipData",
  ReprocessAssetRequest: "assets.v3.ReprocessAssetRequest",
  ReprocessAssetResponse: "assets.v3.ReprocessAssetResponse",
  RequestTooLargeError: "chat.v3.RequestTooLargeError",
  ResourceAccess: "artifacts.v3.ResourceAccess",
  ResourceAttributeCondition: "authz.v3.ResourceAttributeCondition",
  ResourceAttributeKeyPair: "authz.v3.ResourceAttributeKeyPair",
  ResourceConstraints: "entitlements.v3.ResourceConstraints",
  ResourceLimit: "entitlements.v3.ResourceLimit",
  ResourceLimits: "agent.v3.ResourceLimits",
  ResourceReference: "views.v3.ResourceReference",
  RestoreArtifactRequest: "artifacts.v3.RestoreArtifactRequest",
  RestoreArtifactResponse: "artifacts.v3.RestoreArtifactResponse",
  RetryStrategy: "agent.v3.RetryStrategy",
  RevisionStatistics: "agent.v3.activities.artifact_editor.v1.RevisionStatistics",
  RevisionSummary: "agent.v3.activities.artifact_editor.v1.RevisionSummary",
  RevokeRealmPermissionsRequest: "realm.v3.RevokeRealmPermissionsRequest",
  RevokeRealmPermissionsResponse: "realm.v3.RevokeRealmPermissionsResponse",
  RichText: "chat.v3.RichText",
  SEOMetadata: "artifacts.v3.SEOMetadata",
  Scope: "query.v3.Scope",
  ScopeView: "query.v3.ScopeView",
  SearchArtifactsRequest: "artifacts.v3.SearchArtifactsRequest",
  SearchArtifactsResponse: "artifacts.v3.SearchArtifactsResponse",
  SearchAssetsRequest: "assets.v3.SearchAssetsRequest",
  SearchAssetsResponse: "assets.v3.SearchAssetsResponse",
  SearchFacet: "artifacts.v3.SearchFacet",
  SearchFacetValue: "artifacts.v3.SearchFacetValue",
  SearchHighlight: "artifacts.v3.SearchHighlight",
  SearchMetadata: "artifacts.v3.SearchMetadata",
  SearchOptions: "artifacts.v3.SearchOptions",
  SearchResult: "agent.v3.activities.web_search.v1.SearchResult",
  SearchUsersRequest: "users.v3.SearchUsersRequest",
  SearchUsersResponse: "users.v3.SearchUsersResponse",
  ServiceStatus: "status.v3.ServiceStatus",
  Settings: "settings.v3.Settings",
  Share: "common.v3.Share",
  SizeChange: "artifacts.v3.SizeChange",
  SourceAccess: "artifacts.v3.SourceAccess",
  SourceAttribution: "agent.v3.activities.artifact_editor.v1.SourceAttribution",
  SourceAuthor: "artifacts.v3.SourceAuthor",
  SourceCitation: "artifacts.v3.SourceCitation",
  SourceExcerpt: "artifacts.v3.SourceExcerpt",
  SourceMaterial: "agent.v3.activities.artifact_editor.v1.SourceMaterial",
  SourceMetadata: "artifacts.v3.SourceMetadata",
  SourceQuality: "artifacts.v3.SourceQuality",
  SourceUsage: "artifacts.v3.SourceUsage",
  StatsPeriod: "artifacts.v3.StatsPeriod",
  StepError: "agent.v3.StepError",
  StrategyActivityInput: "agent.v3.activities.strategy.v1.StrategyActivityInput",
  StrategyActivityInput_StrategyOptions: "agent.v3.activities.strategy.v1.StrategyActivityInput.StrategyOptions",
  StrategyActivityOutput: "agent.v3.activities.strategy.v1.StrategyActivityOutput",
  StrategyActivityOutput_StrategyMetadata: "agent.v3.activities.strategy.v1.StrategyActivityOutput.StrategyMetadata",
  StrategyActivityResult: "agent.v3.activities.strategy.v1.StrategyActivityResult",
  StrategyState: "agent.v3.activities.strategy.v1.StrategyState",
  StreamPlaybackRequest: "chat.v3.StreamPlaybackRequest",
  StreamPlaybackResponse: "chat.v3.StreamPlaybackResponse",
  StreamRequest: "chat.v3.StreamRequest",
  StreamResponse: "chat.v3.StreamResponse",
  StrikeAttrs: "chat.v3.StrikeAttrs",
  StrongAttrs: "chat.v3.StrongAttrs",
  SubscriptAttrs: "chat.v3.SubscriptAttrs",
  SuperscriptAttrs: "chat.v3.SuperscriptAttrs",
  SyncRequest: "auth.v3.SyncRequest",
  SyncResponse: "auth.v3.SyncResponse",
  SystemPreference: "preferences.v3.SystemPreference",
  TableAttrs: "chat.v3.TableAttrs",
  TableCellAttrs: "chat.v3.TableCellAttrs",
  TextAttachment: "query.v3.TextAttachment",
  TimeConstraints: "entitlements.v3.TimeConstraints",
  TimeLimit: "entitlements.v3.TimeLimit",
  ToolConfig: "agent.v3.ToolConfig",
  ToolError: "agent.v3.ToolError",
  ToolExample: "agent.v3.ToolExample",
  ToolExecutionError: "agent.v3.ToolExecutionError",
  ToolParameter: "agent.v3.ToolParameter",
  ToolParameters: "agent.v3.ToolParameters",
  ToolProperty: "agent.v3.ToolProperty",
  ToolSchema: "agent.v3.ToolSchema",
  ToolSchemaShort: "agent.v3.ToolSchemaShort",
  TriageActivityInput: "agent.v3.activities.triage.v1.TriageActivityInput",
  TriageActivityInput_TriageOptions: "agent.v3.activities.triage.v1.TriageActivityInput.TriageOptions",
  TriageActivityOutput: "agent.v3.activities.triage.v1.TriageActivityOutput",
  TriageActivityOutput_ClarificationRequest: "agent.v3.activities.triage.v1.TriageActivityOutput.ClarificationRequest",
  TriageActivityOutput_DirectResponse: "agent.v3.activities.triage.v1.TriageActivityOutput.DirectResponse",
  TriageActivityResult: "agent.v3.activities.triage.v1.TriageActivityResult",
  TriageState: "agent.v3.activities.triage.v1.TriageState",
  UnpinViewRequest: "views.v3.UnpinViewRequest",
  UnpinViewResponse: "views.v3.UnpinViewResponse",
  UnpublishArtifactRequest: "artifacts.v3.UnpublishArtifactRequest",
  UnpublishArtifactResponse: "artifacts.v3.UnpublishArtifactResponse",
  UpdateArtifactContentRequest: "artifacts.v3.UpdateArtifactContentRequest",
  UpdateArtifactContentResponse: "artifacts.v3.UpdateArtifactContentResponse",
  UpdateArtifactRequest: "artifacts.v3.UpdateArtifactRequest",
  UpdateArtifactResponse: "artifacts.v3.UpdateArtifactResponse",
  UpdateAssetRequest: "assets.v3.UpdateAssetRequest",
  UpdateAssetResponse: "assets.v3.UpdateAssetResponse",
  UpdateAssetStatusRequest: "fileproc.v3.UpdateAssetStatusRequest",
  UpdateAssetStatusResponse: "fileproc.v3.UpdateAssetStatusResponse",
  UpdateLabelRequest: "labels.v3.UpdateLabelRequest",
  UpdateLabelResponse: "labels.v3.UpdateLabelResponse",
  UpdateLastAccessedRequest: "realm.v3.UpdateLastAccessedRequest",
  UpdateLastAccessedResponse: "realm.v3.UpdateLastAccessedResponse",
  UpdateProcessingProgressRequest: "fileproc.v3.UpdateProcessingProgressRequest",
  UpdateProcessingProgressResponse: "fileproc.v3.UpdateProcessingProgressResponse",
  UpdateRealmNamesRequest: "realm.v3.UpdateRealmNamesRequest",
  UpdateRealmNamesResponse: "realm.v3.UpdateRealmNamesResponse",
  UpdateSelfRequest: "users.v3.UpdateSelfRequest",
  UpdateSelfResponse: "users.v3.UpdateSelfResponse",
  UpdateViewRequest: "views.v3.UpdateViewRequest",
  UpdateViewResponse: "views.v3.UpdateViewResponse",
  UploadAssetRequest: "assets.v3.UploadAssetRequest",
  UploadAssetResponse: "assets.v3.UploadAssetResponse",
  UploadProgress: "assets.v3.UploadProgress",
  User: "users.v3.User",
  UserAttribution: "common.v3.UserAttribution",
  UserData: "chat.v3.UserData",
  UserInternal: "users.v3.UserInternal",
  UserKbSearchInput: "agent.v3.activities.user_kb_search.v1.UserKbSearchInput",
  UserKbSearchOutput: "agent.v3.activities.user_kb_search.v1.UserKbSearchOutput",
  UserKbSearchResult: "agent.v3.activities.user_kb_search.v1.UserKbSearchResult",
  UserLearning: "agent.v3.user_memory.v1.UserLearning",
  UserLearning_LearningContent: "agent.v3.user_memory.v1.UserLearning.LearningContent",
  UserLearning_LearningMetadata: "agent.v3.user_memory.v1.UserLearning.LearningMetadata",
  UserMemory: "agent.v3.user_memory.v1.UserMemory",
  UserMemory_MemoryContent: "agent.v3.user_memory.v1.UserMemory.MemoryContent",
  UserMemory_MemoryMetadata: "agent.v3.user_memory.v1.UserMemory.MemoryMetadata",
  UserWithActions: "users.v3.UserWithActions",
  ValidationRequirements: "agent.v3.activities.artifact_editor.v1.ValidationRequirements",
  VariableNodeV1Attrs: "chat.v3.VariableNodeV1Attrs",
  VersionApproval: "artifacts.v3.VersionApproval",
  VersionApprovalRecord: "artifacts.v3.VersionApprovalRecord",
  VersionChange: "artifacts.v3.VersionChange",
  VersionComparison: "artifacts.v3.VersionComparison",
  VersionDifference: "artifacts.v3.VersionDifference",
  VersionQualityMetrics: "artifacts.v3.VersionQualityMetrics",
  VersionSizeInfo: "artifacts.v3.VersionSizeInfo",
  View: "views.v3.View",
  ViewFilter: "views.v3.ViewFilter",
  ViewResultItem: "views.v3.ViewResultItem",
  ViewResults: "views.v3.ViewResults",
  ViewSummary: "views.v3.ViewSummary",
  ViewWithActions: "views.v3.ViewWithActions",
  WebSearchToolInput: "agent.v3.activities.web_search.v1.WebSearchToolInput",
  WebSearchToolOutput: "agent.v3.activities.web_search.v1.WebSearchToolOutput",
  WorkflowConstraints: "entitlements.v3.WorkflowConstraints",
  WorkflowContext: "agent.v3.workflow.v1.WorkflowContext",
  WorkflowError: "agent.v3.WorkflowError",
  WorkflowLimit: "entitlements.v3.WorkflowLimit",
} as const;

export type MessageKind = (typeof MessageKind)[keyof typeof MessageKind];

/**
 * Creates a new message with the correct $typeName automatically assigned.
 */
export function createMessage<T extends (typeof MessageKind)[keyof typeof MessageKind]>(
  type: T,
  data: Partial<Record<string, unknown>> = {},
) {
  return {
    $typeName: type,
    ...data,
  };
}

/**
 * Type-safe helper functions for creating messages
 */
export function createAPIConstraints(data: Partial<Omit<APIConstraints, "$typeName">> = {}): APIConstraints {
  return {
    $typeName: MessageKind.APIConstraints,
    ...data,
  } as APIConstraints;
}

export function createAPILimit(data: Partial<Omit<APILimit, "$typeName">> = {}): APILimit {
  return {
    $typeName: MessageKind.APILimit,
    ...data,
  } as APILimit;
}

export function createAbuseMark(data: Partial<Omit<AbuseMark, "$typeName">> = {}): AbuseMark {
  return {
    $typeName: MessageKind.AbuseMark,
    ...data,
  } as AbuseMark;
}

export function createActionData(data: Partial<Omit<ActionData, "$typeName">> = {}): ActionData {
  return {
    $typeName: MessageKind.ActionData,
    ...data,
  } as ActionData;
}

export function createActivityDefinition(
  data: Partial<Omit<ActivityDefinition, "$typeName">> = {},
): ActivityDefinition {
  return {
    $typeName: MessageKind.ActivityDefinition,
    ...data,
  } as ActivityDefinition;
}

export function createActivityDependency(
  data: Partial<Omit<ActivityDependency, "$typeName">> = {},
): ActivityDependency {
  return {
    $typeName: MessageKind.ActivityDependency,
    ...data,
  } as ActivityDependency;
}

export function createActivityDependencyTemplate(
  data: Partial<Omit<ActivityDependencyTemplate, "$typeName">> = {},
): ActivityDependencyTemplate {
  return {
    $typeName: MessageKind.ActivityDependencyTemplate,
    ...data,
  } as ActivityDependencyTemplate;
}

export function createActivityError(data: Partial<Omit<ActivityError, "$typeName">> = {}): ActivityError {
  return {
    $typeName: MessageKind.ActivityError,
    ...data,
  } as ActivityError;
}

export function createActivityResult(data: Partial<Omit<ActivityResult, "$typeName">> = {}): ActivityResult {
  return {
    $typeName: MessageKind.ActivityResult,
    ...data,
  } as ActivityResult;
}

export function createAggregationBucket(data: Partial<Omit<AggregationBucket, "$typeName">> = {}): AggregationBucket {
  return {
    $typeName: MessageKind.AggregationBucket,
    ...data,
  } as AggregationBucket;
}

export function createAggregationResult(data: Partial<Omit<AggregationResult, "$typeName">> = {}): AggregationResult {
  return {
    $typeName: MessageKind.AggregationResult,
    ...data,
  } as AggregationResult;
}

export function createAnalysisActivityInput(
  data: Partial<Omit<AnalysisActivityInput, "$typeName">> = {},
): AnalysisActivityInput {
  return {
    $typeName: MessageKind.AnalysisActivityInput,
    ...data,
  } as AnalysisActivityInput;
}

export function createAnalysisActivityInput_AnalysisOptions(
  data: Partial<Omit<AnalysisActivityInput_AnalysisOptions, "$typeName">> = {},
): AnalysisActivityInput_AnalysisOptions {
  return {
    $typeName: MessageKind.AnalysisActivityInput_AnalysisOptions,
    ...data,
  } as AnalysisActivityInput_AnalysisOptions;
}

export function createAnalysisActivityInput_Context(
  data: Partial<Omit<AnalysisActivityInput_Context, "$typeName">> = {},
): AnalysisActivityInput_Context {
  return {
    $typeName: MessageKind.AnalysisActivityInput_Context,
    ...data,
  } as AnalysisActivityInput_Context;
}

export function createAnalysisActivityInput_ReferenceMaterial(
  data: Partial<Omit<AnalysisActivityInput_ReferenceMaterial, "$typeName">> = {},
): AnalysisActivityInput_ReferenceMaterial {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceMaterial,
    ...data,
  } as AnalysisActivityInput_ReferenceMaterial;
}

export function createAnalysisActivityInput_ReferenceMaterial_Access(
  data: Partial<Omit<AnalysisActivityInput_ReferenceMaterial_Access, "$typeName">> = {},
): AnalysisActivityInput_ReferenceMaterial_Access {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceMaterial_Access,
    ...data,
  } as AnalysisActivityInput_ReferenceMaterial_Access;
}

export function createAnalysisActivityInput_ReferenceMaterial_ContentSample(
  data: Partial<Omit<AnalysisActivityInput_ReferenceMaterial_ContentSample, "$typeName">> = {},
): AnalysisActivityInput_ReferenceMaterial_ContentSample {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceMaterial_ContentSample,
    ...data,
  } as AnalysisActivityInput_ReferenceMaterial_ContentSample;
}

export function createAnalysisActivityInput_ReferenceMaterial_Relevance(
  data: Partial<Omit<AnalysisActivityInput_ReferenceMaterial_Relevance, "$typeName">> = {},
): AnalysisActivityInput_ReferenceMaterial_Relevance {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceMaterial_Relevance,
    ...data,
  } as AnalysisActivityInput_ReferenceMaterial_Relevance;
}

export function createAnalysisActivityInput_ReferenceMaterial_Source(
  data: Partial<Omit<AnalysisActivityInput_ReferenceMaterial_Source, "$typeName">> = {},
): AnalysisActivityInput_ReferenceMaterial_Source {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceMaterial_Source,
    ...data,
  } as AnalysisActivityInput_ReferenceMaterial_Source;
}

export function createAnalysisActivityInput_ReferenceRelationship(
  data: Partial<Omit<AnalysisActivityInput_ReferenceRelationship, "$typeName">> = {},
): AnalysisActivityInput_ReferenceRelationship {
  return {
    $typeName: MessageKind.AnalysisActivityInput_ReferenceRelationship,
    ...data,
  } as AnalysisActivityInput_ReferenceRelationship;
}

export function createAnalysisActivityOutput(
  data: Partial<Omit<AnalysisActivityOutput, "$typeName">> = {},
): AnalysisActivityOutput {
  return {
    $typeName: MessageKind.AnalysisActivityOutput,
    ...data,
  } as AnalysisActivityOutput;
}

export function createAnalysisActivityOutput_AlternativeIntent(
  data: Partial<Omit<AnalysisActivityOutput_AlternativeIntent, "$typeName">> = {},
): AnalysisActivityOutput_AlternativeIntent {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_AlternativeIntent,
    ...data,
  } as AnalysisActivityOutput_AlternativeIntent;
}

export function createAnalysisActivityOutput_Entity(
  data: Partial<Omit<AnalysisActivityOutput_Entity, "$typeName">> = {},
): AnalysisActivityOutput_Entity {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_Entity,
    ...data,
  } as AnalysisActivityOutput_Entity;
}

export function createAnalysisActivityOutput_LanguageInfo(
  data: Partial<Omit<AnalysisActivityOutput_LanguageInfo, "$typeName">> = {},
): AnalysisActivityOutput_LanguageInfo {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_LanguageInfo,
    ...data,
  } as AnalysisActivityOutput_LanguageInfo;
}

export function createAnalysisActivityOutput_RequestProperties(
  data: Partial<Omit<AnalysisActivityOutput_RequestProperties, "$typeName">> = {},
): AnalysisActivityOutput_RequestProperties {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_RequestProperties,
    ...data,
  } as AnalysisActivityOutput_RequestProperties;
}

export function createAnalysisActivityOutput_Requirement(
  data: Partial<Omit<AnalysisActivityOutput_Requirement, "$typeName">> = {},
): AnalysisActivityOutput_Requirement {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_Requirement,
    ...data,
  } as AnalysisActivityOutput_Requirement;
}

export function createAnalysisActivityOutput_ResponseCharacteristics(
  data: Partial<Omit<AnalysisActivityOutput_ResponseCharacteristics, "$typeName">> = {},
): AnalysisActivityOutput_ResponseCharacteristics {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_ResponseCharacteristics,
    ...data,
  } as AnalysisActivityOutput_ResponseCharacteristics;
}

export function createAnalysisActivityOutput_TemporalInfo(
  data: Partial<Omit<AnalysisActivityOutput_TemporalInfo, "$typeName">> = {},
): AnalysisActivityOutput_TemporalInfo {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_TemporalInfo,
    ...data,
  } as AnalysisActivityOutput_TemporalInfo;
}

export function createAnalysisActivityOutput_TemporalInfo_TimePeriod(
  data: Partial<Omit<AnalysisActivityOutput_TemporalInfo_TimePeriod, "$typeName">> = {},
): AnalysisActivityOutput_TemporalInfo_TimePeriod {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_TemporalInfo_TimePeriod,
    ...data,
  } as AnalysisActivityOutput_TemporalInfo_TimePeriod;
}

export function createAnalysisActivityOutput_TemporalInfo_TimePeriodRelationship(
  data: Partial<Omit<AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship, "$typeName">> = {},
): AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship,
    ...data,
  } as AnalysisActivityOutput_TemporalInfo_TimePeriodRelationship;
}

export function createAnalysisActivityOutput_TemporalInfo_TimePeriod_Duration(
  data: Partial<Omit<AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration, "$typeName">> = {},
): AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration,
    ...data,
  } as AnalysisActivityOutput_TemporalInfo_TimePeriod_Duration;
}

export function createAnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange(
  data: Partial<Omit<AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange, "$typeName">> = {},
): AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange {
  return {
    $typeName: MessageKind.AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange,
    ...data,
  } as AnalysisActivityOutput_TemporalInfo_TimePeriod_TimeRange;
}

export function createAnalysisActivityResult(
  data: Partial<Omit<AnalysisActivityResult, "$typeName">> = {},
): AnalysisActivityResult {
  return {
    $typeName: MessageKind.AnalysisActivityResult,
    ...data,
  } as AnalysisActivityResult;
}

export function createAnalysisState(data: Partial<Omit<AnalysisState, "$typeName">> = {}): AnalysisState {
  return {
    $typeName: MessageKind.AnalysisState,
    ...data,
  } as AnalysisState;
}

export function createApiError(data: Partial<Omit<ApiError, "$typeName">> = {}): ApiError {
  return {
    $typeName: MessageKind.ApiError,
    ...data,
  } as ApiError;
}

export function createAppAppearancePreference(
  data: Partial<Omit<AppAppearancePreference, "$typeName">> = {},
): AppAppearancePreference {
  return {
    $typeName: MessageKind.AppAppearancePreference,
    ...data,
  } as AppAppearancePreference;
}

export function createAppPreferences(data: Partial<Omit<AppPreferences, "$typeName">> = {}): AppPreferences {
  return {
    $typeName: MessageKind.AppPreferences,
    ...data,
  } as AppPreferences;
}

export function createArchiveArtifactRequest(
  data: Partial<Omit<ArchiveArtifactRequest, "$typeName">> = {},
): ArchiveArtifactRequest {
  return {
    $typeName: MessageKind.ArchiveArtifactRequest,
    ...data,
  } as ArchiveArtifactRequest;
}

export function createArchiveArtifactResponse(
  data: Partial<Omit<ArchiveArtifactResponse, "$typeName">> = {},
): ArchiveArtifactResponse {
  return {
    $typeName: MessageKind.ArchiveArtifactResponse,
    ...data,
  } as ArchiveArtifactResponse;
}

export function createArtifact(data: Partial<Omit<Artifact, "$typeName">> = {}): Artifact {
  return {
    $typeName: MessageKind.Artifact,
    ...data,
  } as Artifact;
}

export function createArtifactClassification(
  data: Partial<Omit<ArtifactClassification, "$typeName">> = {},
): ArtifactClassification {
  return {
    $typeName: MessageKind.ArtifactClassification,
    ...data,
  } as ArtifactClassification;
}

export function createArtifactContent(data: Partial<Omit<ArtifactContent, "$typeName">> = {}): ArtifactContent {
  return {
    $typeName: MessageKind.ArtifactContent,
    ...data,
  } as ArtifactContent;
}

export function createArtifactContentMetadata(
  data: Partial<Omit<ArtifactContentMetadata, "$typeName">> = {},
): ArtifactContentMetadata {
  return {
    $typeName: MessageKind.ArtifactContentMetadata,
    ...data,
  } as ArtifactContentMetadata;
}

export function createArtifactFilters(data: Partial<Omit<ArtifactFilters, "$typeName">> = {}): ArtifactFilters {
  return {
    $typeName: MessageKind.ArtifactFilters,
    ...data,
  } as ArtifactFilters;
}

export function createArtifactGenerateToolInput(
  data: Partial<Omit<ArtifactGenerateToolInput, "$typeName">> = {},
): ArtifactGenerateToolInput {
  return {
    $typeName: MessageKind.ArtifactGenerateToolInput,
    ...data,
  } as ArtifactGenerateToolInput;
}

export function createArtifactGenerationInput(
  data: Partial<Omit<ArtifactGenerationInput, "$typeName">> = {},
): ArtifactGenerationInput {
  return {
    $typeName: MessageKind.ArtifactGenerationInput,
    ...data,
  } as ArtifactGenerationInput;
}

export function createArtifactGenerationOutput(
  data: Partial<Omit<ArtifactGenerationOutput, "$typeName">> = {},
): ArtifactGenerationOutput {
  return {
    $typeName: MessageKind.ArtifactGenerationOutput,
    ...data,
  } as ArtifactGenerationOutput;
}

export function createArtifactGenerationRequirements(
  data: Partial<Omit<ArtifactGenerationRequirements, "$typeName">> = {},
): ArtifactGenerationRequirements {
  return {
    $typeName: MessageKind.ArtifactGenerationRequirements,
    ...data,
  } as ArtifactGenerationRequirements;
}

export function createArtifactGenerationResult(
  data: Partial<Omit<ArtifactGenerationResult, "$typeName">> = {},
): ArtifactGenerationResult {
  return {
    $typeName: MessageKind.ArtifactGenerationResult,
    ...data,
  } as ArtifactGenerationResult;
}

export function createArtifactGenerationState(
  data: Partial<Omit<ArtifactGenerationState, "$typeName">> = {},
): ArtifactGenerationState {
  return {
    $typeName: MessageKind.ArtifactGenerationState,
    ...data,
  } as ArtifactGenerationState;
}

export function createArtifactResource(data: Partial<Omit<ArtifactResource, "$typeName">> = {}): ArtifactResource {
  return {
    $typeName: MessageKind.ArtifactResource,
    ...data,
  } as ArtifactResource;
}

export function createArtifactReviseToolInput(
  data: Partial<Omit<ArtifactReviseToolInput, "$typeName">> = {},
): ArtifactReviseToolInput {
  return {
    $typeName: MessageKind.ArtifactReviseToolInput,
    ...data,
  } as ArtifactReviseToolInput;
}

export function createArtifactRevisionInput(
  data: Partial<Omit<ArtifactRevisionInput, "$typeName">> = {},
): ArtifactRevisionInput {
  return {
    $typeName: MessageKind.ArtifactRevisionInput,
    ...data,
  } as ArtifactRevisionInput;
}

export function createArtifactRevisionOutput(
  data: Partial<Omit<ArtifactRevisionOutput, "$typeName">> = {},
): ArtifactRevisionOutput {
  return {
    $typeName: MessageKind.ArtifactRevisionOutput,
    ...data,
  } as ArtifactRevisionOutput;
}

export function createArtifactRevisionRequirements(
  data: Partial<Omit<ArtifactRevisionRequirements, "$typeName">> = {},
): ArtifactRevisionRequirements {
  return {
    $typeName: MessageKind.ArtifactRevisionRequirements,
    ...data,
  } as ArtifactRevisionRequirements;
}

export function createArtifactRevisionResult(
  data: Partial<Omit<ArtifactRevisionResult, "$typeName">> = {},
): ArtifactRevisionResult {
  return {
    $typeName: MessageKind.ArtifactRevisionResult,
    ...data,
  } as ArtifactRevisionResult;
}

export function createArtifactRevisionState(
  data: Partial<Omit<ArtifactRevisionState, "$typeName">> = {},
): ArtifactRevisionState {
  return {
    $typeName: MessageKind.ArtifactRevisionState,
    ...data,
  } as ArtifactRevisionState;
}

export function createArtifactSearchResult(
  data: Partial<Omit<ArtifactSearchResult, "$typeName">> = {},
): ArtifactSearchResult {
  return {
    $typeName: MessageKind.ArtifactSearchResult,
    ...data,
  } as ArtifactSearchResult;
}

export function createArtifactSource(data: Partial<Omit<ArtifactSource, "$typeName">> = {}): ArtifactSource {
  return {
    $typeName: MessageKind.ArtifactSource,
    ...data,
  } as ArtifactSource;
}

export function createArtifactSummary(data: Partial<Omit<ArtifactSummary, "$typeName">> = {}): ArtifactSummary {
  return {
    $typeName: MessageKind.ArtifactSummary,
    ...data,
  } as ArtifactSummary;
}

export function createArtifactUsageStats(
  data: Partial<Omit<ArtifactUsageStats, "$typeName">> = {},
): ArtifactUsageStats {
  return {
    $typeName: MessageKind.ArtifactUsageStats,
    ...data,
  } as ArtifactUsageStats;
}

export function createArtifactVersion(data: Partial<Omit<ArtifactVersion, "$typeName">> = {}): ArtifactVersion {
  return {
    $typeName: MessageKind.ArtifactVersion,
    ...data,
  } as ArtifactVersion;
}

export function createArtifactWithActions(
  data: Partial<Omit<ArtifactWithActions, "$typeName">> = {},
): ArtifactWithActions {
  return {
    $typeName: MessageKind.ArtifactWithActions,
    ...data,
  } as ArtifactWithActions;
}

export function createAsset(data: Partial<Omit<Asset, "$typeName">> = {}): Asset {
  return {
    $typeName: MessageKind.Asset,
    ...data,
  } as Asset;
}

export function createAssetFilters(data: Partial<Omit<AssetFilters, "$typeName">> = {}): AssetFilters {
  return {
    $typeName: MessageKind.AssetFilters,
    ...data,
  } as AssetFilters;
}

export function createAssetJobStatus(data: Partial<Omit<AssetJobStatus, "$typeName">> = {}): AssetJobStatus {
  return {
    $typeName: MessageKind.AssetJobStatus,
    ...data,
  } as AssetJobStatus;
}

export function createAssetProcessingProgress(
  data: Partial<Omit<AssetProcessingProgress, "$typeName">> = {},
): AssetProcessingProgress {
  return {
    $typeName: MessageKind.AssetProcessingProgress,
    ...data,
  } as AssetProcessingProgress;
}

export function createAssetProcessingSpec(
  data: Partial<Omit<AssetProcessingSpec, "$typeName">> = {},
): AssetProcessingSpec {
  return {
    $typeName: MessageKind.AssetProcessingSpec,
    ...data,
  } as AssetProcessingSpec;
}

export function createAssetProcessingStatus(
  data: Partial<Omit<AssetProcessingStatus, "$typeName">> = {},
): AssetProcessingStatus {
  return {
    $typeName: MessageKind.AssetProcessingStatus,
    ...data,
  } as AssetProcessingStatus;
}

export function createAssetProcessingStatusWithActions(
  data: Partial<Omit<AssetProcessingStatusWithActions, "$typeName">> = {},
): AssetProcessingStatusWithActions {
  return {
    $typeName: MessageKind.AssetProcessingStatusWithActions,
    ...data,
  } as AssetProcessingStatusWithActions;
}

export function createAssetWithActions(data: Partial<Omit<AssetWithActions, "$typeName">> = {}): AssetWithActions {
  return {
    $typeName: MessageKind.AssetWithActions,
    ...data,
  } as AssetWithActions;
}

export function createAssetWithLabels(data: Partial<Omit<AssetWithLabels, "$typeName">> = {}): AssetWithLabels {
  return {
    $typeName: MessageKind.AssetWithLabels,
    ...data,
  } as AssetWithLabels;
}

export function createAssociateLabelRequest(
  data: Partial<Omit<AssociateLabelRequest, "$typeName">> = {},
): AssociateLabelRequest {
  return {
    $typeName: MessageKind.AssociateLabelRequest,
    ...data,
  } as AssociateLabelRequest;
}

export function createAssociateLabelResponse(
  data: Partial<Omit<AssociateLabelResponse, "$typeName">> = {},
): AssociateLabelResponse {
  return {
    $typeName: MessageKind.AssociateLabelResponse,
    ...data,
  } as AssociateLabelResponse;
}

export function createAuditMetadata(data: Partial<Omit<AuditMetadata, "$typeName">> = {}): AuditMetadata {
  return {
    $typeName: MessageKind.AuditMetadata,
    ...data,
  } as AuditMetadata;
}

export function createAuthenticatedInternalUser(
  data: Partial<Omit<AuthenticatedInternalUser, "$typeName">> = {},
): AuthenticatedInternalUser {
  return {
    $typeName: MessageKind.AuthenticatedInternalUser,
    ...data,
  } as AuthenticatedInternalUser;
}

export function createAuthenticatedUser(data: Partial<Omit<AuthenticatedUser, "$typeName">> = {}): AuthenticatedUser {
  return {
    $typeName: MessageKind.AuthenticatedUser,
    ...data,
  } as AuthenticatedUser;
}

export function createAuthenticationError(
  data: Partial<Omit<AuthenticationError, "$typeName">> = {},
): AuthenticationError {
  return {
    $typeName: MessageKind.AuthenticationError,
    ...data,
  } as AuthenticationError;
}

export function createAvailabilityConstraints(
  data: Partial<Omit<AvailabilityConstraints, "$typeName">> = {},
): AvailabilityConstraints {
  return {
    $typeName: MessageKind.AvailabilityConstraints,
    ...data,
  } as AvailabilityConstraints;
}

export function createAvailabilityControl(
  data: Partial<Omit<AvailabilityControl, "$typeName">> = {},
): AvailabilityControl {
  return {
    $typeName: MessageKind.AvailabilityControl,
    ...data,
  } as AvailabilityControl;
}

export function createAvailableRealm(data: Partial<Omit<AvailableRealm, "$typeName">> = {}): AvailableRealm {
  return {
    $typeName: MessageKind.AvailableRealm,
    ...data,
  } as AvailableRealm;
}

export function createAvailableRealmWithNames(
  data: Partial<Omit<AvailableRealmWithNames, "$typeName">> = {},
): AvailableRealmWithNames {
  return {
    $typeName: MessageKind.AvailableRealmWithNames,
    ...data,
  } as AvailableRealmWithNames;
}

export function createBatchConstraints(data: Partial<Omit<BatchConstraints, "$typeName">> = {}): BatchConstraints {
  return {
    $typeName: MessageKind.BatchConstraints,
    ...data,
  } as BatchConstraints;
}

export function createBatchLimit(data: Partial<Omit<BatchLimit, "$typeName">> = {}): BatchLimit {
  return {
    $typeName: MessageKind.BatchLimit,
    ...data,
  } as BatchLimit;
}

export function createBlockquoteAttrs(data: Partial<Omit<BlockquoteAttrs, "$typeName">> = {}): BlockquoteAttrs {
  return {
    $typeName: MessageKind.BlockquoteAttrs,
    ...data,
  } as BlockquoteAttrs;
}

export function createBulkArtifactUpdate(
  data: Partial<Omit<BulkArtifactUpdate, "$typeName">> = {},
): BulkArtifactUpdate {
  return {
    $typeName: MessageKind.BulkArtifactUpdate,
    ...data,
  } as BulkArtifactUpdate;
}

export function createBulkAssociateLabelsRequest(
  data: Partial<Omit<BulkAssociateLabelsRequest, "$typeName">> = {},
): BulkAssociateLabelsRequest {
  return {
    $typeName: MessageKind.BulkAssociateLabelsRequest,
    ...data,
  } as BulkAssociateLabelsRequest;
}

export function createBulkAssociateLabelsResponse(
  data: Partial<Omit<BulkAssociateLabelsResponse, "$typeName">> = {},
): BulkAssociateLabelsResponse {
  return {
    $typeName: MessageKind.BulkAssociateLabelsResponse,
    ...data,
  } as BulkAssociateLabelsResponse;
}

export function createBulkDeleteArtifactsRequest(
  data: Partial<Omit<BulkDeleteArtifactsRequest, "$typeName">> = {},
): BulkDeleteArtifactsRequest {
  return {
    $typeName: MessageKind.BulkDeleteArtifactsRequest,
    ...data,
  } as BulkDeleteArtifactsRequest;
}

export function createBulkDeleteArtifactsResponse(
  data: Partial<Omit<BulkDeleteArtifactsResponse, "$typeName">> = {},
): BulkDeleteArtifactsResponse {
  return {
    $typeName: MessageKind.BulkDeleteArtifactsResponse,
    ...data,
  } as BulkDeleteArtifactsResponse;
}

export function createBulkDisassociateLabelsRequest(
  data: Partial<Omit<BulkDisassociateLabelsRequest, "$typeName">> = {},
): BulkDisassociateLabelsRequest {
  return {
    $typeName: MessageKind.BulkDisassociateLabelsRequest,
    ...data,
  } as BulkDisassociateLabelsRequest;
}

export function createBulkDisassociateLabelsResponse(
  data: Partial<Omit<BulkDisassociateLabelsResponse, "$typeName">> = {},
): BulkDisassociateLabelsResponse {
  return {
    $typeName: MessageKind.BulkDisassociateLabelsResponse,
    ...data,
  } as BulkDisassociateLabelsResponse;
}

export function createBulkResourceTarget(
  data: Partial<Omit<BulkResourceTarget, "$typeName">> = {},
): BulkResourceTarget {
  return {
    $typeName: MessageKind.BulkResourceTarget,
    ...data,
  } as BulkResourceTarget;
}

export function createBulkUpdateArtifactsRequest(
  data: Partial<Omit<BulkUpdateArtifactsRequest, "$typeName">> = {},
): BulkUpdateArtifactsRequest {
  return {
    $typeName: MessageKind.BulkUpdateArtifactsRequest,
    ...data,
  } as BulkUpdateArtifactsRequest;
}

export function createBulkUpdateArtifactsResponse(
  data: Partial<Omit<BulkUpdateArtifactsResponse, "$typeName">> = {},
): BulkUpdateArtifactsResponse {
  return {
    $typeName: MessageKind.BulkUpdateArtifactsResponse,
    ...data,
  } as BulkUpdateArtifactsResponse;
}

export function createChangeComparison(data: Partial<Omit<ChangeComparison, "$typeName">> = {}): ChangeComparison {
  return {
    $typeName: MessageKind.ChangeComparison,
    ...data,
  } as ChangeComparison;
}

export function createChangeImpactAssessment(
  data: Partial<Omit<ChangeImpactAssessment, "$typeName">> = {},
): ChangeImpactAssessment {
  return {
    $typeName: MessageKind.ChangeImpactAssessment,
    ...data,
  } as ChangeImpactAssessment;
}

export function createChangeRequirements(
  data: Partial<Omit<ChangeRequirements, "$typeName">> = {},
): ChangeRequirements {
  return {
    $typeName: MessageKind.ChangeRequirements,
    ...data,
  } as ChangeRequirements;
}

export function createChangeStats(data: Partial<Omit<ChangeStats, "$typeName">> = {}): ChangeStats {
  return {
    $typeName: MessageKind.ChangeStats,
    ...data,
  } as ChangeStats;
}

export function createChatRequest(data: Partial<Omit<ChatRequest, "$typeName">> = {}): ChatRequest {
  return {
    $typeName: MessageKind.ChatRequest,
    ...data,
  } as ChatRequest;
}

export function createChatResponse(data: Partial<Omit<ChatResponse, "$typeName">> = {}): ChatResponse {
  return {
    $typeName: MessageKind.ChatResponse,
    ...data,
  } as ChatResponse;
}

export function createChatWorkflowInput(data: Partial<Omit<ChatWorkflowInput, "$typeName">> = {}): ChatWorkflowInput {
  return {
    $typeName: MessageKind.ChatWorkflowInput,
    ...data,
  } as ChatWorkflowInput;
}

export function createCheckPermissionRequest(
  data: Partial<Omit<CheckPermissionRequest, "$typeName">> = {},
): CheckPermissionRequest {
  return {
    $typeName: MessageKind.CheckPermissionRequest,
    ...data,
  } as CheckPermissionRequest;
}

export function createCheckPermissionResponse(
  data: Partial<Omit<CheckPermissionResponse, "$typeName">> = {},
): CheckPermissionResponse {
  return {
    $typeName: MessageKind.CheckPermissionResponse,
    ...data,
  } as CheckPermissionResponse;
}

export function createCheckRequest(data: Partial<Omit<CheckRequest, "$typeName">> = {}): CheckRequest {
  return {
    $typeName: MessageKind.CheckRequest,
    ...data,
  } as CheckRequest;
}

export function createCheckResponse(data: Partial<Omit<CheckResponse, "$typeName">> = {}): CheckResponse {
  return {
    $typeName: MessageKind.CheckResponse,
    ...data,
  } as CheckResponse;
}

export function createChunkInfo(data: Partial<Omit<ChunkInfo, "$typeName">> = {}): ChunkInfo {
  return {
    $typeName: MessageKind.ChunkInfo,
    ...data,
  } as ChunkInfo;
}

export function createCitationFormats(data: Partial<Omit<CitationFormats, "$typeName">> = {}): CitationFormats {
  return {
    $typeName: MessageKind.CitationFormats,
    ...data,
  } as CitationFormats;
}

export function createCodeAttrs(data: Partial<Omit<CodeAttrs, "$typeName">> = {}): CodeAttrs {
  return {
    $typeName: MessageKind.CodeAttrs,
    ...data,
  } as CodeAttrs;
}

export function createCodeBlockAttrs(data: Partial<Omit<CodeBlockAttrs, "$typeName">> = {}): CodeBlockAttrs {
  return {
    $typeName: MessageKind.CodeBlockAttrs,
    ...data,
  } as CodeBlockAttrs;
}

export function createCompareArtifactVersionsRequest(
  data: Partial<Omit<CompareArtifactVersionsRequest, "$typeName">> = {},
): CompareArtifactVersionsRequest {
  return {
    $typeName: MessageKind.CompareArtifactVersionsRequest,
    ...data,
  } as CompareArtifactVersionsRequest;
}

export function createCompareArtifactVersionsResponse(
  data: Partial<Omit<CompareArtifactVersionsResponse, "$typeName">> = {},
): CompareArtifactVersionsResponse {
  return {
    $typeName: MessageKind.CompareArtifactVersionsResponse,
    ...data,
  } as CompareArtifactVersionsResponse;
}

export function createComparisonOptions(data: Partial<Omit<ComparisonOptions, "$typeName">> = {}): ComparisonOptions {
  return {
    $typeName: MessageKind.ComparisonOptions,
    ...data,
  } as ComparisonOptions;
}

export function createCompleteAssetProcessingRequest(
  data: Partial<Omit<CompleteAssetProcessingRequest, "$typeName">> = {},
): CompleteAssetProcessingRequest {
  return {
    $typeName: MessageKind.CompleteAssetProcessingRequest,
    ...data,
  } as CompleteAssetProcessingRequest;
}

export function createCompleteAssetProcessingResponse(
  data: Partial<Omit<CompleteAssetProcessingResponse, "$typeName">> = {},
): CompleteAssetProcessingResponse {
  return {
    $typeName: MessageKind.CompleteAssetProcessingResponse,
    ...data,
  } as CompleteAssetProcessingResponse;
}

export function createCompleteAssetUploadRequest(
  data: Partial<Omit<CompleteAssetUploadRequest, "$typeName">> = {},
): CompleteAssetUploadRequest {
  return {
    $typeName: MessageKind.CompleteAssetUploadRequest,
    ...data,
  } as CompleteAssetUploadRequest;
}

export function createCompleteAssetUploadResponse(
  data: Partial<Omit<CompleteAssetUploadResponse, "$typeName">> = {},
): CompleteAssetUploadResponse {
  return {
    $typeName: MessageKind.CompleteAssetUploadResponse,
    ...data,
  } as CompleteAssetUploadResponse;
}

export function createComplianceConstraints(
  data: Partial<Omit<ComplianceConstraints, "$typeName">> = {},
): ComplianceConstraints {
  return {
    $typeName: MessageKind.ComplianceConstraints,
    ...data,
  } as ComplianceConstraints;
}

export function createComplianceControl(data: Partial<Omit<ComplianceControl, "$typeName">> = {}): ComplianceControl {
  return {
    $typeName: MessageKind.ComplianceControl,
    ...data,
  } as ComplianceControl;
}

export function createConceptData(data: Partial<Omit<ConceptData, "$typeName">> = {}): ConceptData {
  return {
    $typeName: MessageKind.ConceptData,
    ...data,
  } as ConceptData;
}

export function createCondition(data: Partial<Omit<Condition, "$typeName">> = {}): Condition {
  return {
    $typeName: MessageKind.Condition,
    ...data,
  } as Condition;
}

export function createConditionalDependency(
  data: Partial<Omit<ConditionalDependency, "$typeName">> = {},
): ConditionalDependency {
  return {
    $typeName: MessageKind.ConditionalDependency,
    ...data,
  } as ConditionalDependency;
}

export function createConfidenceScoreCondition(
  data: Partial<Omit<ConfidenceScoreCondition, "$typeName">> = {},
): ConfidenceScoreCondition {
  return {
    $typeName: MessageKind.ConfidenceScoreCondition,
    ...data,
  } as ConfidenceScoreCondition;
}

export function createConflictResolution(
  data: Partial<Omit<ConflictResolution, "$typeName">> = {},
): ConflictResolution {
  return {
    $typeName: MessageKind.ConflictResolution,
    ...data,
  } as ConflictResolution;
}

export function createContentAnalysisMetadata(
  data: Partial<Omit<ContentAnalysisMetadata, "$typeName">> = {},
): ContentAnalysisMetadata {
  return {
    $typeName: MessageKind.ContentAnalysisMetadata,
    ...data,
  } as ContentAnalysisMetadata;
}

export function createContentConstraints(
  data: Partial<Omit<ContentConstraints, "$typeName">> = {},
): ContentConstraints {
  return {
    $typeName: MessageKind.ContentConstraints,
    ...data,
  } as ContentConstraints;
}

export function createContentLimit(data: Partial<Omit<ContentLimit, "$typeName">> = {}): ContentLimit {
  return {
    $typeName: MessageKind.ContentLimit,
    ...data,
  } as ContentLimit;
}

export function createContentRequirements(
  data: Partial<Omit<ContentRequirements, "$typeName">> = {},
): ContentRequirements {
  return {
    $typeName: MessageKind.ContentRequirements,
    ...data,
  } as ContentRequirements;
}

export function createContentSection(data: Partial<Omit<ContentSection, "$typeName">> = {}): ContentSection {
  return {
    $typeName: MessageKind.ContentSection,
    ...data,
  } as ContentSection;
}

export function createContentSentiment(data: Partial<Omit<ContentSentiment, "$typeName">> = {}): ContentSentiment {
  return {
    $typeName: MessageKind.ContentSentiment,
    ...data,
  } as ContentSentiment;
}

export function createContentSnapshot(data: Partial<Omit<ContentSnapshot, "$typeName">> = {}): ContentSnapshot {
  return {
    $typeName: MessageKind.ContentSnapshot,
    ...data,
  } as ContentSnapshot;
}

export function createContextScope(data: Partial<Omit<ContextScope, "$typeName">> = {}): ContextScope {
  return {
    $typeName: MessageKind.ContextScope,
    ...data,
  } as ContextScope;
}

export function createConversationContext(
  data: Partial<Omit<ConversationContext, "$typeName">> = {},
): ConversationContext {
  return {
    $typeName: MessageKind.ConversationContext,
    ...data,
  } as ConversationContext;
}

export function createConversationContext_Message(
  data: Partial<Omit<ConversationContext_Message, "$typeName">> = {},
): ConversationContext_Message {
  return {
    $typeName: MessageKind.ConversationContext_Message,
    ...data,
  } as ConversationContext_Message;
}

export function createConversationContext_UserPreferences(
  data: Partial<Omit<ConversationContext_UserPreferences, "$typeName">> = {},
): ConversationContext_UserPreferences {
  return {
    $typeName: MessageKind.ConversationContext_UserPreferences,
    ...data,
  } as ConversationContext_UserPreferences;
}

export function createConversationRequest(
  data: Partial<Omit<ConversationRequest, "$typeName">> = {},
): ConversationRequest {
  return {
    $typeName: MessageKind.ConversationRequest,
    ...data,
  } as ConversationRequest;
}

export function createConversationResponse(
  data: Partial<Omit<ConversationResponse, "$typeName">> = {},
): ConversationResponse {
  return {
    $typeName: MessageKind.ConversationResponse,
    ...data,
  } as ConversationResponse;
}

export function createConvertArtifactFormatRequest(
  data: Partial<Omit<ConvertArtifactFormatRequest, "$typeName">> = {},
): ConvertArtifactFormatRequest {
  return {
    $typeName: MessageKind.ConvertArtifactFormatRequest,
    ...data,
  } as ConvertArtifactFormatRequest;
}

export function createConvertArtifactFormatResponse(
  data: Partial<Omit<ConvertArtifactFormatResponse, "$typeName">> = {},
): ConvertArtifactFormatResponse {
  return {
    $typeName: MessageKind.ConvertArtifactFormatResponse,
    ...data,
  } as ConvertArtifactFormatResponse;
}

export function createCreateArtifactRequest(
  data: Partial<Omit<CreateArtifactRequest, "$typeName">> = {},
): CreateArtifactRequest {
  return {
    $typeName: MessageKind.CreateArtifactRequest,
    ...data,
  } as CreateArtifactRequest;
}

export function createCreateArtifactResponse(
  data: Partial<Omit<CreateArtifactResponse, "$typeName">> = {},
): CreateArtifactResponse {
  return {
    $typeName: MessageKind.CreateArtifactResponse,
    ...data,
  } as CreateArtifactResponse;
}

export function createCreateArtifactVersionRequest(
  data: Partial<Omit<CreateArtifactVersionRequest, "$typeName">> = {},
): CreateArtifactVersionRequest {
  return {
    $typeName: MessageKind.CreateArtifactVersionRequest,
    ...data,
  } as CreateArtifactVersionRequest;
}

export function createCreateArtifactVersionResponse(
  data: Partial<Omit<CreateArtifactVersionResponse, "$typeName">> = {},
): CreateArtifactVersionResponse {
  return {
    $typeName: MessageKind.CreateArtifactVersionResponse,
    ...data,
  } as CreateArtifactVersionResponse;
}

export function createCreateAssetRequest(
  data: Partial<Omit<CreateAssetRequest, "$typeName">> = {},
): CreateAssetRequest {
  return {
    $typeName: MessageKind.CreateAssetRequest,
    ...data,
  } as CreateAssetRequest;
}

export function createCreateAssetResponse(
  data: Partial<Omit<CreateAssetResponse, "$typeName">> = {},
): CreateAssetResponse {
  return {
    $typeName: MessageKind.CreateAssetResponse,
    ...data,
  } as CreateAssetResponse;
}

export function createCreateLabelRequest(
  data: Partial<Omit<CreateLabelRequest, "$typeName">> = {},
): CreateLabelRequest {
  return {
    $typeName: MessageKind.CreateLabelRequest,
    ...data,
  } as CreateLabelRequest;
}

export function createCreateLabelResponse(
  data: Partial<Omit<CreateLabelResponse, "$typeName">> = {},
): CreateLabelResponse {
  return {
    $typeName: MessageKind.CreateLabelResponse,
    ...data,
  } as CreateLabelResponse;
}

export function createCreateOrganizationRequest(
  data: Partial<Omit<CreateOrganizationRequest, "$typeName">> = {},
): CreateOrganizationRequest {
  return {
    $typeName: MessageKind.CreateOrganizationRequest,
    ...data,
  } as CreateOrganizationRequest;
}

export function createCreateOrganizationResponse(
  data: Partial<Omit<CreateOrganizationResponse, "$typeName">> = {},
): CreateOrganizationResponse {
  return {
    $typeName: MessageKind.CreateOrganizationResponse,
    ...data,
  } as CreateOrganizationResponse;
}

export function createCreateProjectRequest(
  data: Partial<Omit<CreateProjectRequest, "$typeName">> = {},
): CreateProjectRequest {
  return {
    $typeName: MessageKind.CreateProjectRequest,
    ...data,
  } as CreateProjectRequest;
}

export function createCreateProjectResponse(
  data: Partial<Omit<CreateProjectResponse, "$typeName">> = {},
): CreateProjectResponse {
  return {
    $typeName: MessageKind.CreateProjectResponse,
    ...data,
  } as CreateProjectResponse;
}

export function createCreateTenantRequest(
  data: Partial<Omit<CreateTenantRequest, "$typeName">> = {},
): CreateTenantRequest {
  return {
    $typeName: MessageKind.CreateTenantRequest,
    ...data,
  } as CreateTenantRequest;
}

export function createCreateTenantResponse(
  data: Partial<Omit<CreateTenantResponse, "$typeName">> = {},
): CreateTenantResponse {
  return {
    $typeName: MessageKind.CreateTenantResponse,
    ...data,
  } as CreateTenantResponse;
}

export function createCreateViewRequest(data: Partial<Omit<CreateViewRequest, "$typeName">> = {}): CreateViewRequest {
  return {
    $typeName: MessageKind.CreateViewRequest,
    ...data,
  } as CreateViewRequest;
}

export function createCreateViewResponse(
  data: Partial<Omit<CreateViewResponse, "$typeName">> = {},
): CreateViewResponse {
  return {
    $typeName: MessageKind.CreateViewResponse,
    ...data,
  } as CreateViewResponse;
}

export function createCreateWorkspaceRequest(
  data: Partial<Omit<CreateWorkspaceRequest, "$typeName">> = {},
): CreateWorkspaceRequest {
  return {
    $typeName: MessageKind.CreateWorkspaceRequest,
    ...data,
  } as CreateWorkspaceRequest;
}

export function createCreateWorkspaceResponse(
  data: Partial<Omit<CreateWorkspaceResponse, "$typeName">> = {},
): CreateWorkspaceResponse {
  return {
    $typeName: MessageKind.CreateWorkspaceResponse,
    ...data,
  } as CreateWorkspaceResponse;
}

export function createDataSecurityClassificationCondition(
  data: Partial<Omit<DataSecurityClassificationCondition, "$typeName">> = {},
): DataSecurityClassificationCondition {
  return {
    $typeName: MessageKind.DataSecurityClassificationCondition,
    ...data,
  } as DataSecurityClassificationCondition;
}

export function createDeleteArtifactRequest(
  data: Partial<Omit<DeleteArtifactRequest, "$typeName">> = {},
): DeleteArtifactRequest {
  return {
    $typeName: MessageKind.DeleteArtifactRequest,
    ...data,
  } as DeleteArtifactRequest;
}

export function createDeleteArtifactResponse(
  data: Partial<Omit<DeleteArtifactResponse, "$typeName">> = {},
): DeleteArtifactResponse {
  return {
    $typeName: MessageKind.DeleteArtifactResponse,
    ...data,
  } as DeleteArtifactResponse;
}

export function createDeleteAssetRequest(
  data: Partial<Omit<DeleteAssetRequest, "$typeName">> = {},
): DeleteAssetRequest {
  return {
    $typeName: MessageKind.DeleteAssetRequest,
    ...data,
  } as DeleteAssetRequest;
}

export function createDeleteAssetResponse(
  data: Partial<Omit<DeleteAssetResponse, "$typeName">> = {},
): DeleteAssetResponse {
  return {
    $typeName: MessageKind.DeleteAssetResponse,
    ...data,
  } as DeleteAssetResponse;
}

export function createDeleteLabelRequest(
  data: Partial<Omit<DeleteLabelRequest, "$typeName">> = {},
): DeleteLabelRequest {
  return {
    $typeName: MessageKind.DeleteLabelRequest,
    ...data,
  } as DeleteLabelRequest;
}

export function createDeleteLabelResponse(
  data: Partial<Omit<DeleteLabelResponse, "$typeName">> = {},
): DeleteLabelResponse {
  return {
    $typeName: MessageKind.DeleteLabelResponse,
    ...data,
  } as DeleteLabelResponse;
}

export function createDeleteViewRequest(data: Partial<Omit<DeleteViewRequest, "$typeName">> = {}): DeleteViewRequest {
  return {
    $typeName: MessageKind.DeleteViewRequest,
    ...data,
  } as DeleteViewRequest;
}

export function createDeleteViewResponse(
  data: Partial<Omit<DeleteViewResponse, "$typeName">> = {},
): DeleteViewResponse {
  return {
    $typeName: MessageKind.DeleteViewResponse,
    ...data,
  } as DeleteViewResponse;
}

export function createDisassociateLabelRequest(
  data: Partial<Omit<DisassociateLabelRequest, "$typeName">> = {},
): DisassociateLabelRequest {
  return {
    $typeName: MessageKind.DisassociateLabelRequest,
    ...data,
  } as DisassociateLabelRequest;
}

export function createDisassociateLabelResponse(
  data: Partial<Omit<DisassociateLabelResponse, "$typeName">> = {},
): DisassociateLabelResponse {
  return {
    $typeName: MessageKind.DisassociateLabelResponse,
    ...data,
  } as DisassociateLabelResponse;
}

export function createDocAttrs(data: Partial<Omit<DocAttrs, "$typeName">> = {}): DocAttrs {
  return {
    $typeName: MessageKind.DocAttrs,
    ...data,
  } as DocAttrs;
}

export function createEmAttrs(data: Partial<Omit<EmAttrs, "$typeName">> = {}): EmAttrs {
  return {
    $typeName: MessageKind.EmAttrs,
    ...data,
  } as EmAttrs;
}

export function createEmailAddress(data: Partial<Omit<EmailAddress, "$typeName">> = {}): EmailAddress {
  return {
    $typeName: MessageKind.EmailAddress,
    ...data,
  } as EmailAddress;
}

export function createEmbedding(data: Partial<Omit<Embedding, "$typeName">> = {}): Embedding {
  return {
    $typeName: MessageKind.Embedding,
    ...data,
  } as Embedding;
}

export function createEmotionalTone(data: Partial<Omit<EmotionalTone, "$typeName">> = {}): EmotionalTone {
  return {
    $typeName: MessageKind.EmotionalTone,
    ...data,
  } as EmotionalTone;
}

export function createEncryptionMetadata(
  data: Partial<Omit<EncryptionMetadata, "$typeName">> = {},
): EncryptionMetadata {
  return {
    $typeName: MessageKind.EncryptionMetadata,
    ...data,
  } as EncryptionMetadata;
}

export function createEnrichedScope(data: Partial<Omit<EnrichedScope, "$typeName">> = {}): EnrichedScope {
  return {
    $typeName: MessageKind.EnrichedScope,
    ...data,
  } as EnrichedScope;
}

export function createEntitlement(data: Partial<Omit<Entitlement, "$typeName">> = {}): Entitlement {
  return {
    $typeName: MessageKind.Entitlement,
    ...data,
  } as Entitlement;
}

export function createEstimatedResourceRequirements(
  data: Partial<Omit<EstimatedResourceRequirements, "$typeName">> = {},
): EstimatedResourceRequirements {
  return {
    $typeName: MessageKind.EstimatedResourceRequirements,
    ...data,
  } as EstimatedResourceRequirements;
}

export function createExecuteViewRequest(
  data: Partial<Omit<ExecuteViewRequest, "$typeName">> = {},
): ExecuteViewRequest {
  return {
    $typeName: MessageKind.ExecuteViewRequest,
    ...data,
  } as ExecuteViewRequest;
}

export function createExecuteViewResponse(
  data: Partial<Omit<ExecuteViewResponse, "$typeName">> = {},
): ExecuteViewResponse {
  return {
    $typeName: MessageKind.ExecuteViewResponse,
    ...data,
  } as ExecuteViewResponse;
}

export function createExecutionActivityInput(
  data: Partial<Omit<ExecutionActivityInput, "$typeName">> = {},
): ExecutionActivityInput {
  return {
    $typeName: MessageKind.ExecutionActivityInput,
    ...data,
  } as ExecutionActivityInput;
}

export function createExecutionContext(data: Partial<Omit<ExecutionContext, "$typeName">> = {}): ExecutionContext {
  return {
    $typeName: MessageKind.ExecutionContext,
    ...data,
  } as ExecutionContext;
}

export function createExecutionStep(data: Partial<Omit<ExecutionStep, "$typeName">> = {}): ExecutionStep {
  return {
    $typeName: MessageKind.ExecutionStep,
    ...data,
  } as ExecutionStep;
}

export function createExecutionStepOutput(
  data: Partial<Omit<ExecutionStepOutput, "$typeName">> = {},
): ExecutionStepOutput {
  return {
    $typeName: MessageKind.ExecutionStepOutput,
    ...data,
  } as ExecutionStepOutput;
}

export function createExecutionStepResult(
  data: Partial<Omit<ExecutionStepResult, "$typeName">> = {},
): ExecutionStepResult {
  return {
    $typeName: MessageKind.ExecutionStepResult,
    ...data,
  } as ExecutionStepResult;
}

export function createExecutionStep_StepOptions(
  data: Partial<Omit<ExecutionStep_StepOptions, "$typeName">> = {},
): ExecutionStep_StepOptions {
  return {
    $typeName: MessageKind.ExecutionStep_StepOptions,
    ...data,
  } as ExecutionStep_StepOptions;
}

export function createExportArtifactRequest(
  data: Partial<Omit<ExportArtifactRequest, "$typeName">> = {},
): ExportArtifactRequest {
  return {
    $typeName: MessageKind.ExportArtifactRequest,
    ...data,
  } as ExportArtifactRequest;
}

export function createExportArtifactResponse(
  data: Partial<Omit<ExportArtifactResponse, "$typeName">> = {},
): ExportArtifactResponse {
  return {
    $typeName: MessageKind.ExportArtifactResponse,
    ...data,
  } as ExportArtifactResponse;
}

export function createExportOptions(data: Partial<Omit<ExportOptions, "$typeName">> = {}): ExportOptions {
  return {
    $typeName: MessageKind.ExportOptions,
    ...data,
  } as ExportOptions;
}

export function createExternalIdentifier(
  data: Partial<Omit<ExternalIdentifier, "$typeName">> = {},
): ExternalIdentifier {
  return {
    $typeName: MessageKind.ExternalIdentifier,
    ...data,
  } as ExternalIdentifier;
}

export function createFileAttachment(data: Partial<Omit<FileAttachment, "$typeName">> = {}): FileAttachment {
  return {
    $typeName: MessageKind.FileAttachment,
    ...data,
  } as FileAttachment;
}

export function createFileData(data: Partial<Omit<FileData, "$typeName">> = {}): FileData {
  return {
    $typeName: MessageKind.FileData,
    ...data,
  } as FileData;
}

export function createFloatLimit(data: Partial<Omit<FloatLimit, "$typeName">> = {}): FloatLimit {
  return {
    $typeName: MessageKind.FloatLimit,
    ...data,
  } as FloatLimit;
}

export function createForkArtifactRequest(
  data: Partial<Omit<ForkArtifactRequest, "$typeName">> = {},
): ForkArtifactRequest {
  return {
    $typeName: MessageKind.ForkArtifactRequest,
    ...data,
  } as ForkArtifactRequest;
}

export function createForkArtifactResponse(
  data: Partial<Omit<ForkArtifactResponse, "$typeName">> = {},
): ForkArtifactResponse {
  return {
    $typeName: MessageKind.ForkArtifactResponse,
    ...data,
  } as ForkArtifactResponse;
}

export function createFormatRequirements(
  data: Partial<Omit<FormatRequirements, "$typeName">> = {},
): FormatRequirements {
  return {
    $typeName: MessageKind.FormatRequirements,
    ...data,
  } as FormatRequirements;
}

export function createGenerationContext(data: Partial<Omit<GenerationContext, "$typeName">> = {}): GenerationContext {
  return {
    $typeName: MessageKind.GenerationContext,
    ...data,
  } as GenerationContext;
}

export function createGenerationStatistics(
  data: Partial<Omit<GenerationStatistics, "$typeName">> = {},
): GenerationStatistics {
  return {
    $typeName: MessageKind.GenerationStatistics,
    ...data,
  } as GenerationStatistics;
}

export function createGenerationSummary(data: Partial<Omit<GenerationSummary, "$typeName">> = {}): GenerationSummary {
  return {
    $typeName: MessageKind.GenerationSummary,
    ...data,
  } as GenerationSummary;
}

export function createGetArtifactContentHistoryRequest(
  data: Partial<Omit<GetArtifactContentHistoryRequest, "$typeName">> = {},
): GetArtifactContentHistoryRequest {
  return {
    $typeName: MessageKind.GetArtifactContentHistoryRequest,
    ...data,
  } as GetArtifactContentHistoryRequest;
}

export function createGetArtifactContentHistoryResponse(
  data: Partial<Omit<GetArtifactContentHistoryResponse, "$typeName">> = {},
): GetArtifactContentHistoryResponse {
  return {
    $typeName: MessageKind.GetArtifactContentHistoryResponse,
    ...data,
  } as GetArtifactContentHistoryResponse;
}

export function createGetArtifactContentRequest(
  data: Partial<Omit<GetArtifactContentRequest, "$typeName">> = {},
): GetArtifactContentRequest {
  return {
    $typeName: MessageKind.GetArtifactContentRequest,
    ...data,
  } as GetArtifactContentRequest;
}

export function createGetArtifactContentResponse(
  data: Partial<Omit<GetArtifactContentResponse, "$typeName">> = {},
): GetArtifactContentResponse {
  return {
    $typeName: MessageKind.GetArtifactContentResponse,
    ...data,
  } as GetArtifactContentResponse;
}

export function createGetArtifactRequest(
  data: Partial<Omit<GetArtifactRequest, "$typeName">> = {},
): GetArtifactRequest {
  return {
    $typeName: MessageKind.GetArtifactRequest,
    ...data,
  } as GetArtifactRequest;
}

export function createGetArtifactResponse(
  data: Partial<Omit<GetArtifactResponse, "$typeName">> = {},
): GetArtifactResponse {
  return {
    $typeName: MessageKind.GetArtifactResponse,
    ...data,
  } as GetArtifactResponse;
}

export function createGetArtifactStatsRequest(
  data: Partial<Omit<GetArtifactStatsRequest, "$typeName">> = {},
): GetArtifactStatsRequest {
  return {
    $typeName: MessageKind.GetArtifactStatsRequest,
    ...data,
  } as GetArtifactStatsRequest;
}

export function createGetArtifactStatsResponse(
  data: Partial<Omit<GetArtifactStatsResponse, "$typeName">> = {},
): GetArtifactStatsResponse {
  return {
    $typeName: MessageKind.GetArtifactStatsResponse,
    ...data,
  } as GetArtifactStatsResponse;
}

export function createGetArtifactVersionRequest(
  data: Partial<Omit<GetArtifactVersionRequest, "$typeName">> = {},
): GetArtifactVersionRequest {
  return {
    $typeName: MessageKind.GetArtifactVersionRequest,
    ...data,
  } as GetArtifactVersionRequest;
}

export function createGetArtifactVersionResponse(
  data: Partial<Omit<GetArtifactVersionResponse, "$typeName">> = {},
): GetArtifactVersionResponse {
  return {
    $typeName: MessageKind.GetArtifactVersionResponse,
    ...data,
  } as GetArtifactVersionResponse;
}

export function createGetAssetJobStatusRequest(
  data: Partial<Omit<GetAssetJobStatusRequest, "$typeName">> = {},
): GetAssetJobStatusRequest {
  return {
    $typeName: MessageKind.GetAssetJobStatusRequest,
    ...data,
  } as GetAssetJobStatusRequest;
}

export function createGetAssetJobStatusResponse(
  data: Partial<Omit<GetAssetJobStatusResponse, "$typeName">> = {},
): GetAssetJobStatusResponse {
  return {
    $typeName: MessageKind.GetAssetJobStatusResponse,
    ...data,
  } as GetAssetJobStatusResponse;
}

export function createGetAssetRequest(data: Partial<Omit<GetAssetRequest, "$typeName">> = {}): GetAssetRequest {
  return {
    $typeName: MessageKind.GetAssetRequest,
    ...data,
  } as GetAssetRequest;
}

export function createGetAssetResponse(data: Partial<Omit<GetAssetResponse, "$typeName">> = {}): GetAssetResponse {
  return {
    $typeName: MessageKind.GetAssetResponse,
    ...data,
  } as GetAssetResponse;
}

export function createGetAssetsRequest(data: Partial<Omit<GetAssetsRequest, "$typeName">> = {}): GetAssetsRequest {
  return {
    $typeName: MessageKind.GetAssetsRequest,
    ...data,
  } as GetAssetsRequest;
}

export function createGetAssetsResponse(data: Partial<Omit<GetAssetsResponse, "$typeName">> = {}): GetAssetsResponse {
  return {
    $typeName: MessageKind.GetAssetsResponse,
    ...data,
  } as GetAssetsResponse;
}

export function createGetBulkAssetJobStatusRequest(
  data: Partial<Omit<GetBulkAssetJobStatusRequest, "$typeName">> = {},
): GetBulkAssetJobStatusRequest {
  return {
    $typeName: MessageKind.GetBulkAssetJobStatusRequest,
    ...data,
  } as GetBulkAssetJobStatusRequest;
}

export function createGetBulkAssetJobStatusResponse(
  data: Partial<Omit<GetBulkAssetJobStatusResponse, "$typeName">> = {},
): GetBulkAssetJobStatusResponse {
  return {
    $typeName: MessageKind.GetBulkAssetJobStatusResponse,
    ...data,
  } as GetBulkAssetJobStatusResponse;
}

export function createGetLabelRequest(data: Partial<Omit<GetLabelRequest, "$typeName">> = {}): GetLabelRequest {
  return {
    $typeName: MessageKind.GetLabelRequest,
    ...data,
  } as GetLabelRequest;
}

export function createGetLabelResourcesRequest(
  data: Partial<Omit<GetLabelResourcesRequest, "$typeName">> = {},
): GetLabelResourcesRequest {
  return {
    $typeName: MessageKind.GetLabelResourcesRequest,
    ...data,
  } as GetLabelResourcesRequest;
}

export function createGetLabelResourcesResponse(
  data: Partial<Omit<GetLabelResourcesResponse, "$typeName">> = {},
): GetLabelResourcesResponse {
  return {
    $typeName: MessageKind.GetLabelResourcesResponse,
    ...data,
  } as GetLabelResourcesResponse;
}

export function createGetLabelResponse(data: Partial<Omit<GetLabelResponse, "$typeName">> = {}): GetLabelResponse {
  return {
    $typeName: MessageKind.GetLabelResponse,
    ...data,
  } as GetLabelResponse;
}

export function createGetPinnedViewsRequest(
  data: Partial<Omit<GetPinnedViewsRequest, "$typeName">> = {},
): GetPinnedViewsRequest {
  return {
    $typeName: MessageKind.GetPinnedViewsRequest,
    ...data,
  } as GetPinnedViewsRequest;
}

export function createGetPinnedViewsResponse(
  data: Partial<Omit<GetPinnedViewsResponse, "$typeName">> = {},
): GetPinnedViewsResponse {
  return {
    $typeName: MessageKind.GetPinnedViewsResponse,
    ...data,
  } as GetPinnedViewsResponse;
}

export function createGetRealmRequest(data: Partial<Omit<GetRealmRequest, "$typeName">> = {}): GetRealmRequest {
  return {
    $typeName: MessageKind.GetRealmRequest,
    ...data,
  } as GetRealmRequest;
}

export function createGetRealmResponse(data: Partial<Omit<GetRealmResponse, "$typeName">> = {}): GetRealmResponse {
  return {
    $typeName: MessageKind.GetRealmResponse,
    ...data,
  } as GetRealmResponse;
}

export function createGetRelatedArtifactsRequest(
  data: Partial<Omit<GetRelatedArtifactsRequest, "$typeName">> = {},
): GetRelatedArtifactsRequest {
  return {
    $typeName: MessageKind.GetRelatedArtifactsRequest,
    ...data,
  } as GetRelatedArtifactsRequest;
}

export function createGetRelatedArtifactsResponse(
  data: Partial<Omit<GetRelatedArtifactsResponse, "$typeName">> = {},
): GetRelatedArtifactsResponse {
  return {
    $typeName: MessageKind.GetRelatedArtifactsResponse,
    ...data,
  } as GetRelatedArtifactsResponse;
}

export function createGetResourceLabelsRequest(
  data: Partial<Omit<GetResourceLabelsRequest, "$typeName">> = {},
): GetResourceLabelsRequest {
  return {
    $typeName: MessageKind.GetResourceLabelsRequest,
    ...data,
  } as GetResourceLabelsRequest;
}

export function createGetResourceLabelsResponse(
  data: Partial<Omit<GetResourceLabelsResponse, "$typeName">> = {},
): GetResourceLabelsResponse {
  return {
    $typeName: MessageKind.GetResourceLabelsResponse,
    ...data,
  } as GetResourceLabelsResponse;
}

export function createGetSelfRequest(data: Partial<Omit<GetSelfRequest, "$typeName">> = {}): GetSelfRequest {
  return {
    $typeName: MessageKind.GetSelfRequest,
    ...data,
  } as GetSelfRequest;
}

export function createGetSelfResponse(data: Partial<Omit<GetSelfResponse, "$typeName">> = {}): GetSelfResponse {
  return {
    $typeName: MessageKind.GetSelfResponse,
    ...data,
  } as GetSelfResponse;
}

export function createGetUserRequest(data: Partial<Omit<GetUserRequest, "$typeName">> = {}): GetUserRequest {
  return {
    $typeName: MessageKind.GetUserRequest,
    ...data,
  } as GetUserRequest;
}

export function createGetUserResponse(data: Partial<Omit<GetUserResponse, "$typeName">> = {}): GetUserResponse {
  return {
    $typeName: MessageKind.GetUserResponse,
    ...data,
  } as GetUserResponse;
}

export function createGetViewRequest(data: Partial<Omit<GetViewRequest, "$typeName">> = {}): GetViewRequest {
  return {
    $typeName: MessageKind.GetViewRequest,
    ...data,
  } as GetViewRequest;
}

export function createGetViewResponse(data: Partial<Omit<GetViewResponse, "$typeName">> = {}): GetViewResponse {
  return {
    $typeName: MessageKind.GetViewResponse,
    ...data,
  } as GetViewResponse;
}

export function createGrantPermissionRequest(
  data: Partial<Omit<GrantPermissionRequest, "$typeName">> = {},
): GrantPermissionRequest {
  return {
    $typeName: MessageKind.GrantPermissionRequest,
    ...data,
  } as GrantPermissionRequest;
}

export function createGrantPermissionResponse(
  data: Partial<Omit<GrantPermissionResponse, "$typeName">> = {},
): GrantPermissionResponse {
  return {
    $typeName: MessageKind.GrantPermissionResponse,
    ...data,
  } as GrantPermissionResponse;
}

export function createGrantRealmPermissionsRequest(
  data: Partial<Omit<GrantRealmPermissionsRequest, "$typeName">> = {},
): GrantRealmPermissionsRequest {
  return {
    $typeName: MessageKind.GrantRealmPermissionsRequest,
    ...data,
  } as GrantRealmPermissionsRequest;
}

export function createGrantRealmPermissionsResponse(
  data: Partial<Omit<GrantRealmPermissionsResponse, "$typeName">> = {},
): GrantRealmPermissionsResponse {
  return {
    $typeName: MessageKind.GrantRealmPermissionsResponse,
    ...data,
  } as GrantRealmPermissionsResponse;
}

export function createHandleProcessingErrorRequest(
  data: Partial<Omit<HandleProcessingErrorRequest, "$typeName">> = {},
): HandleProcessingErrorRequest {
  return {
    $typeName: MessageKind.HandleProcessingErrorRequest,
    ...data,
  } as HandleProcessingErrorRequest;
}

export function createHandleProcessingErrorResponse(
  data: Partial<Omit<HandleProcessingErrorResponse, "$typeName">> = {},
): HandleProcessingErrorResponse {
  return {
    $typeName: MessageKind.HandleProcessingErrorResponse,
    ...data,
  } as HandleProcessingErrorResponse;
}

export function createHeadingAttrs(data: Partial<Omit<HeadingAttrs, "$typeName">> = {}): HeadingAttrs {
  return {
    $typeName: MessageKind.HeadingAttrs,
    ...data,
  } as HeadingAttrs;
}

export function createHealthCheckStats(data: Partial<Omit<HealthCheckStats, "$typeName">> = {}): HealthCheckStats {
  return {
    $typeName: MessageKind.HealthCheckStats,
    ...data,
  } as HealthCheckStats;
}

export function createHighlightAttrs(data: Partial<Omit<HighlightAttrs, "$typeName">> = {}): HighlightAttrs {
  return {
    $typeName: MessageKind.HighlightAttrs,
    ...data,
  } as HighlightAttrs;
}

export function createHorizontalRuleAttrs(
  data: Partial<Omit<HorizontalRuleAttrs, "$typeName">> = {},
): HorizontalRuleAttrs {
  return {
    $typeName: MessageKind.HorizontalRuleAttrs,
    ...data,
  } as HorizontalRuleAttrs;
}

export function createImageAttrs(data: Partial<Omit<ImageAttrs, "$typeName">> = {}): ImageAttrs {
  return {
    $typeName: MessageKind.ImageAttrs,
    ...data,
  } as ImageAttrs;
}

export function createImportInfo(data: Partial<Omit<ImportInfo, "$typeName">> = {}): ImportInfo {
  return {
    $typeName: MessageKind.ImportInfo,
    ...data,
  } as ImportInfo;
}

export function createIngestConstraints(data: Partial<Omit<IngestConstraints, "$typeName">> = {}): IngestConstraints {
  return {
    $typeName: MessageKind.IngestConstraints,
    ...data,
  } as IngestConstraints;
}

export function createIngestLimit(data: Partial<Omit<IngestLimit, "$typeName">> = {}): IngestLimit {
  return {
    $typeName: MessageKind.IngestLimit,
    ...data,
  } as IngestLimit;
}

export function createIntegerLimit(data: Partial<Omit<IntegerLimit, "$typeName">> = {}): IntegerLimit {
  return {
    $typeName: MessageKind.IntegerLimit,
    ...data,
  } as IntegerLimit;
}

export function createInvalidRequestError(
  data: Partial<Omit<InvalidRequestError, "$typeName">> = {},
): InvalidRequestError {
  return {
    $typeName: MessageKind.InvalidRequestError,
    ...data,
  } as InvalidRequestError;
}

export function createLLMTelemetry(data: Partial<Omit<LLMTelemetry, "$typeName">> = {}): LLMTelemetry {
  return {
    $typeName: MessageKind.LLMTelemetry,
    ...data,
  } as LLMTelemetry;
}

export function createLabel(data: Partial<Omit<Label, "$typeName">> = {}): Label {
  return {
    $typeName: MessageKind.Label,
    ...data,
  } as Label;
}

export function createLabelAssociation(data: Partial<Omit<LabelAssociation, "$typeName">> = {}): LabelAssociation {
  return {
    $typeName: MessageKind.LabelAssociation,
    ...data,
  } as LabelAssociation;
}

export function createLabelData(data: Partial<Omit<LabelData, "$typeName">> = {}): LabelData {
  return {
    $typeName: MessageKind.LabelData,
    ...data,
  } as LabelData;
}

export function createLabelSummary(data: Partial<Omit<LabelSummary, "$typeName">> = {}): LabelSummary {
  return {
    $typeName: MessageKind.LabelSummary,
    ...data,
  } as LabelSummary;
}

export function createLabelWithActions(data: Partial<Omit<LabelWithActions, "$typeName">> = {}): LabelWithActions {
  return {
    $typeName: MessageKind.LabelWithActions,
    ...data,
  } as LabelWithActions;
}

export function createLimitPeriod(data: Partial<Omit<LimitPeriod, "$typeName">> = {}): LimitPeriod {
  return {
    $typeName: MessageKind.LimitPeriod,
    ...data,
  } as LimitPeriod;
}

export function createLineRange(data: Partial<Omit<LineRange, "$typeName">> = {}): LineRange {
  return {
    $typeName: MessageKind.LineRange,
    ...data,
  } as LineRange;
}

export function createLinkAttrs(data: Partial<Omit<LinkAttrs, "$typeName">> = {}): LinkAttrs {
  return {
    $typeName: MessageKind.LinkAttrs,
    ...data,
  } as LinkAttrs;
}

export function createListAllRealmsRequest(
  data: Partial<Omit<ListAllRealmsRequest, "$typeName">> = {},
): ListAllRealmsRequest {
  return {
    $typeName: MessageKind.ListAllRealmsRequest,
    ...data,
  } as ListAllRealmsRequest;
}

export function createListAllRealmsResponse(
  data: Partial<Omit<ListAllRealmsResponse, "$typeName">> = {},
): ListAllRealmsResponse {
  return {
    $typeName: MessageKind.ListAllRealmsResponse,
    ...data,
  } as ListAllRealmsResponse;
}

export function createListArtifactVersionsRequest(
  data: Partial<Omit<ListArtifactVersionsRequest, "$typeName">> = {},
): ListArtifactVersionsRequest {
  return {
    $typeName: MessageKind.ListArtifactVersionsRequest,
    ...data,
  } as ListArtifactVersionsRequest;
}

export function createListArtifactVersionsResponse(
  data: Partial<Omit<ListArtifactVersionsResponse, "$typeName">> = {},
): ListArtifactVersionsResponse {
  return {
    $typeName: MessageKind.ListArtifactVersionsResponse,
    ...data,
  } as ListArtifactVersionsResponse;
}

export function createListArtifactsRequest(
  data: Partial<Omit<ListArtifactsRequest, "$typeName">> = {},
): ListArtifactsRequest {
  return {
    $typeName: MessageKind.ListArtifactsRequest,
    ...data,
  } as ListArtifactsRequest;
}

export function createListArtifactsResponse(
  data: Partial<Omit<ListArtifactsResponse, "$typeName">> = {},
): ListArtifactsResponse {
  return {
    $typeName: MessageKind.ListArtifactsResponse,
    ...data,
  } as ListArtifactsResponse;
}

export function createListAssetsRequest(data: Partial<Omit<ListAssetsRequest, "$typeName">> = {}): ListAssetsRequest {
  return {
    $typeName: MessageKind.ListAssetsRequest,
    ...data,
  } as ListAssetsRequest;
}

export function createListAssetsResponse(
  data: Partial<Omit<ListAssetsResponse, "$typeName">> = {},
): ListAssetsResponse {
  return {
    $typeName: MessageKind.ListAssetsResponse,
    ...data,
  } as ListAssetsResponse;
}

export function createListAttrs(data: Partial<Omit<ListAttrs, "$typeName">> = {}): ListAttrs {
  return {
    $typeName: MessageKind.ListAttrs,
    ...data,
  } as ListAttrs;
}

export function createListAvailableRealmsRequest(
  data: Partial<Omit<ListAvailableRealmsRequest, "$typeName">> = {},
): ListAvailableRealmsRequest {
  return {
    $typeName: MessageKind.ListAvailableRealmsRequest,
    ...data,
  } as ListAvailableRealmsRequest;
}

export function createListAvailableRealmsResponse(
  data: Partial<Omit<ListAvailableRealmsResponse, "$typeName">> = {},
): ListAvailableRealmsResponse {
  return {
    $typeName: MessageKind.ListAvailableRealmsResponse,
    ...data,
  } as ListAvailableRealmsResponse;
}

export function createListItemAttrs(data: Partial<Omit<ListItemAttrs, "$typeName">> = {}): ListItemAttrs {
  return {
    $typeName: MessageKind.ListItemAttrs,
    ...data,
  } as ListItemAttrs;
}

export function createListLabelsRequest(data: Partial<Omit<ListLabelsRequest, "$typeName">> = {}): ListLabelsRequest {
  return {
    $typeName: MessageKind.ListLabelsRequest,
    ...data,
  } as ListLabelsRequest;
}

export function createListLabelsResponse(
  data: Partial<Omit<ListLabelsResponse, "$typeName">> = {},
): ListLabelsResponse {
  return {
    $typeName: MessageKind.ListLabelsResponse,
    ...data,
  } as ListLabelsResponse;
}

export function createListRealmUserPermissionsRequest(
  data: Partial<Omit<ListRealmUserPermissionsRequest, "$typeName">> = {},
): ListRealmUserPermissionsRequest {
  return {
    $typeName: MessageKind.ListRealmUserPermissionsRequest,
    ...data,
  } as ListRealmUserPermissionsRequest;
}

export function createListRealmUserPermissionsResponse(
  data: Partial<Omit<ListRealmUserPermissionsResponse, "$typeName">> = {},
): ListRealmUserPermissionsResponse {
  return {
    $typeName: MessageKind.ListRealmUserPermissionsResponse,
    ...data,
  } as ListRealmUserPermissionsResponse;
}

export function createListUserRealmPermissionsRequest(
  data: Partial<Omit<ListUserRealmPermissionsRequest, "$typeName">> = {},
): ListUserRealmPermissionsRequest {
  return {
    $typeName: MessageKind.ListUserRealmPermissionsRequest,
    ...data,
  } as ListUserRealmPermissionsRequest;
}

export function createListUserRealmPermissionsResponse(
  data: Partial<Omit<ListUserRealmPermissionsResponse, "$typeName">> = {},
): ListUserRealmPermissionsResponse {
  return {
    $typeName: MessageKind.ListUserRealmPermissionsResponse,
    ...data,
  } as ListUserRealmPermissionsResponse;
}

export function createListUsersRequest(data: Partial<Omit<ListUsersRequest, "$typeName">> = {}): ListUsersRequest {
  return {
    $typeName: MessageKind.ListUsersRequest,
    ...data,
  } as ListUsersRequest;
}

export function createListUsersResponse(data: Partial<Omit<ListUsersResponse, "$typeName">> = {}): ListUsersResponse {
  return {
    $typeName: MessageKind.ListUsersResponse,
    ...data,
  } as ListUsersResponse;
}

export function createListViewsRequest(data: Partial<Omit<ListViewsRequest, "$typeName">> = {}): ListViewsRequest {
  return {
    $typeName: MessageKind.ListViewsRequest,
    ...data,
  } as ListViewsRequest;
}

export function createListViewsResponse(data: Partial<Omit<ListViewsResponse, "$typeName">> = {}): ListViewsResponse {
  return {
    $typeName: MessageKind.ListViewsResponse,
    ...data,
  } as ListViewsResponse;
}

export function createMark(data: Partial<Omit<Mark, "$typeName">> = {}): Mark {
  return {
    $typeName: MessageKind.Mark,
    ...data,
  } as Mark;
}

export function createMemoryObservationSummary(
  data: Partial<Omit<MemoryObservationSummary, "$typeName">> = {},
): MemoryObservationSummary {
  return {
    $typeName: MessageKind.MemoryObservationSummary,
    ...data,
  } as MemoryObservationSummary;
}

export function createMemoryUpdate(data: Partial<Omit<MemoryUpdate, "$typeName">> = {}): MemoryUpdate {
  return {
    $typeName: MessageKind.MemoryUpdate,
    ...data,
  } as MemoryUpdate;
}

export function createMemoryUpdate_ObservationContent(
  data: Partial<Omit<MemoryUpdate_ObservationContent, "$typeName">> = {},
): MemoryUpdate_ObservationContent {
  return {
    $typeName: MessageKind.MemoryUpdate_ObservationContent,
    ...data,
  } as MemoryUpdate_ObservationContent;
}

export function createMemoryUpdate_ObservationContent_Conflict(
  data: Partial<Omit<MemoryUpdate_ObservationContent_Conflict, "$typeName">> = {},
): MemoryUpdate_ObservationContent_Conflict {
  return {
    $typeName: MessageKind.MemoryUpdate_ObservationContent_Conflict,
    ...data,
  } as MemoryUpdate_ObservationContent_Conflict;
}

export function createMentionData(data: Partial<Omit<MentionData, "$typeName">> = {}): MentionData {
  return {
    $typeName: MessageKind.MentionData,
    ...data,
  } as MentionData;
}

export function createMentionNodeAttrs(data: Partial<Omit<MentionNodeAttrs, "$typeName">> = {}): MentionNodeAttrs {
  return {
    $typeName: MessageKind.MentionNodeAttrs,
    ...data,
  } as MentionNodeAttrs;
}

export function createMergeArtifactRequest(
  data: Partial<Omit<MergeArtifactRequest, "$typeName">> = {},
): MergeArtifactRequest {
  return {
    $typeName: MessageKind.MergeArtifactRequest,
    ...data,
  } as MergeArtifactRequest;
}

export function createMergeArtifactResponse(
  data: Partial<Omit<MergeArtifactResponse, "$typeName">> = {},
): MergeArtifactResponse {
  return {
    $typeName: MessageKind.MergeArtifactResponse,
    ...data,
  } as MergeArtifactResponse;
}

export function createMergeConflict(data: Partial<Omit<MergeConflict, "$typeName">> = {}): MergeConflict {
  return {
    $typeName: MessageKind.MergeConflict,
    ...data,
  } as MergeConflict;
}

export function createMergeInfo(data: Partial<Omit<MergeInfo, "$typeName">> = {}): MergeInfo {
  return {
    $typeName: MessageKind.MergeInfo,
    ...data,
  } as MergeInfo;
}

export function createMessageErrorData(data: Partial<Omit<MessageErrorData, "$typeName">> = {}): MessageErrorData {
  return {
    $typeName: MessageKind.MessageErrorData,
    ...data,
  } as MessageErrorData;
}

export function createMessageLimitData(data: Partial<Omit<MessageLimitData, "$typeName">> = {}): MessageLimitData {
  return {
    $typeName: MessageKind.MessageLimitData,
    ...data,
  } as MessageLimitData;
}

export function createMessagePingData(data: Partial<Omit<MessagePingData, "$typeName">> = {}): MessagePingData {
  return {
    $typeName: MessageKind.MessagePingData,
    ...data,
  } as MessagePingData;
}

export function createMessageWarningData(
  data: Partial<Omit<MessageWarningData, "$typeName">> = {},
): MessageWarningData {
  return {
    $typeName: MessageKind.MessageWarningData,
    ...data,
  } as MessageWarningData;
}

export function createModelAccessSettings(
  data: Partial<Omit<ModelAccessSettings, "$typeName">> = {},
): ModelAccessSettings {
  return {
    $typeName: MessageKind.ModelAccessSettings,
    ...data,
  } as ModelAccessSettings;
}

export function createModelAccessSystemPreference(
  data: Partial<Omit<ModelAccessSystemPreference, "$typeName">> = {},
): ModelAccessSystemPreference {
  return {
    $typeName: MessageKind.ModelAccessSystemPreference,
    ...data,
  } as ModelAccessSystemPreference;
}

export function createMultiFormatContent(
  data: Partial<Omit<MultiFormatContent, "$typeName">> = {},
): MultiFormatContent {
  return {
    $typeName: MessageKind.MultiFormatContent,
    ...data,
  } as MultiFormatContent;
}

export function createNode(data: Partial<Omit<Node, "$typeName">> = {}): Node {
  return {
    $typeName: MessageKind.Node,
    ...data,
  } as Node;
}

export function createNotFoundError(data: Partial<Omit<NotFoundError, "$typeName">> = {}): NotFoundError {
  return {
    $typeName: MessageKind.NotFoundError,
    ...data,
  } as NotFoundError;
}

export function createOperationContext(data: Partial<Omit<OperationContext, "$typeName">> = {}): OperationContext {
  return {
    $typeName: MessageKind.OperationContext,
    ...data,
  } as OperationContext;
}

export function createOriginatingRequest(
  data: Partial<Omit<OriginatingRequest, "$typeName">> = {},
): OriginatingRequest {
  return {
    $typeName: MessageKind.OriginatingRequest,
    ...data,
  } as OriginatingRequest;
}

export function createOverloadedError(data: Partial<Omit<OverloadedError, "$typeName">> = {}): OverloadedError {
  return {
    $typeName: MessageKind.OverloadedError,
    ...data,
  } as OverloadedError;
}

export function createParagraphAttrs(data: Partial<Omit<ParagraphAttrs, "$typeName">> = {}): ParagraphAttrs {
  return {
    $typeName: MessageKind.ParagraphAttrs,
    ...data,
  } as ParagraphAttrs;
}

export function createPermission(data: Partial<Omit<Permission, "$typeName">> = {}): Permission {
  return {
    $typeName: MessageKind.Permission,
    ...data,
  } as Permission;
}

export function createPermissionError(data: Partial<Omit<PermissionError, "$typeName">> = {}): PermissionError {
  return {
    $typeName: MessageKind.PermissionError,
    ...data,
  } as PermissionError;
}

export function createPinViewRequest(data: Partial<Omit<PinViewRequest, "$typeName">> = {}): PinViewRequest {
  return {
    $typeName: MessageKind.PinViewRequest,
    ...data,
  } as PinViewRequest;
}

export function createPinViewResponse(data: Partial<Omit<PinViewResponse, "$typeName">> = {}): PinViewResponse {
  return {
    $typeName: MessageKind.PinViewResponse,
    ...data,
  } as PinViewResponse;
}

export function createPreferences(data: Partial<Omit<Preferences, "$typeName">> = {}): Preferences {
  return {
    $typeName: MessageKind.Preferences,
    ...data,
  } as Preferences;
}

export function createPreviewViewRequest(
  data: Partial<Omit<PreviewViewRequest, "$typeName">> = {},
): PreviewViewRequest {
  return {
    $typeName: MessageKind.PreviewViewRequest,
    ...data,
  } as PreviewViewRequest;
}

export function createPreviewViewResponse(
  data: Partial<Omit<PreviewViewResponse, "$typeName">> = {},
): PreviewViewResponse {
  return {
    $typeName: MessageKind.PreviewViewResponse,
    ...data,
  } as PreviewViewResponse;
}

export function createProcessingMetadata(
  data: Partial<Omit<ProcessingMetadata, "$typeName">> = {},
): ProcessingMetadata {
  return {
    $typeName: MessageKind.ProcessingMetadata,
    ...data,
  } as ProcessingMetadata;
}

export function createProcessingResult(data: Partial<Omit<ProcessingResult, "$typeName">> = {}): ProcessingResult {
  return {
    $typeName: MessageKind.ProcessingResult,
    ...data,
  } as ProcessingResult;
}

export function createProcessingStepUpdate(
  data: Partial<Omit<ProcessingStepUpdate, "$typeName">> = {},
): ProcessingStepUpdate {
  return {
    $typeName: MessageKind.ProcessingStepUpdate,
    ...data,
  } as ProcessingStepUpdate;
}

export function createProcessingTimeMetrics(
  data: Partial<Omit<ProcessingTimeMetrics, "$typeName">> = {},
): ProcessingTimeMetrics {
  return {
    $typeName: MessageKind.ProcessingTimeMetrics,
    ...data,
  } as ProcessingTimeMetrics;
}

export function createPrompt(data: Partial<Omit<Prompt, "$typeName">> = {}): Prompt {
  return {
    $typeName: MessageKind.Prompt,
    ...data,
  } as Prompt;
}

export function createPublicationRequirements(
  data: Partial<Omit<PublicationRequirements, "$typeName">> = {},
): PublicationRequirements {
  return {
    $typeName: MessageKind.PublicationRequirements,
    ...data,
  } as PublicationRequirements;
}

export function createPublishArtifactRequest(
  data: Partial<Omit<PublishArtifactRequest, "$typeName">> = {},
): PublishArtifactRequest {
  return {
    $typeName: MessageKind.PublishArtifactRequest,
    ...data,
  } as PublishArtifactRequest;
}

export function createPublishArtifactResponse(
  data: Partial<Omit<PublishArtifactResponse, "$typeName">> = {},
): PublishArtifactResponse {
  return {
    $typeName: MessageKind.PublishArtifactResponse,
    ...data,
  } as PublishArtifactResponse;
}

export function createPublishingInfo(data: Partial<Omit<PublishingInfo, "$typeName">> = {}): PublishingInfo {
  return {
    $typeName: MessageKind.PublishingInfo,
    ...data,
  } as PublishingInfo;
}

export function createQualityAssessment(data: Partial<Omit<QualityAssessment, "$typeName">> = {}): QualityAssessment {
  return {
    $typeName: MessageKind.QualityAssessment,
    ...data,
  } as QualityAssessment;
}

export function createQualityComparison(data: Partial<Omit<QualityComparison, "$typeName">> = {}): QualityComparison {
  return {
    $typeName: MessageKind.QualityComparison,
    ...data,
  } as QualityComparison;
}

export function createQualityImprovement(
  data: Partial<Omit<QualityImprovement, "$typeName">> = {},
): QualityImprovement {
  return {
    $typeName: MessageKind.QualityImprovement,
    ...data,
  } as QualityImprovement;
}

export function createQualityIssue(data: Partial<Omit<QualityIssue, "$typeName">> = {}): QualityIssue {
  return {
    $typeName: MessageKind.QualityIssue,
    ...data,
  } as QualityIssue;
}

export function createQualityMetrics(data: Partial<Omit<QualityMetrics, "$typeName">> = {}): QualityMetrics {
  return {
    $typeName: MessageKind.QualityMetrics,
    ...data,
  } as QualityMetrics;
}

export function createQualityRequirements(
  data: Partial<Omit<QualityRequirements, "$typeName">> = {},
): QualityRequirements {
  return {
    $typeName: MessageKind.QualityRequirements,
    ...data,
  } as QualityRequirements;
}

export function createQuotaConstraints(data: Partial<Omit<QuotaConstraints, "$typeName">> = {}): QuotaConstraints {
  return {
    $typeName: MessageKind.QuotaConstraints,
    ...data,
  } as QuotaConstraints;
}

export function createQuotaLimit(data: Partial<Omit<QuotaLimit, "$typeName">> = {}): QuotaLimit {
  return {
    $typeName: MessageKind.QuotaLimit,
    ...data,
  } as QuotaLimit;
}

export function createRateConstraints(data: Partial<Omit<RateConstraints, "$typeName">> = {}): RateConstraints {
  return {
    $typeName: MessageKind.RateConstraints,
    ...data,
  } as RateConstraints;
}

export function createRateLimit(data: Partial<Omit<RateLimit, "$typeName">> = {}): RateLimit {
  return {
    $typeName: MessageKind.RateLimit,
    ...data,
  } as RateLimit;
}

export function createRateLimitError(data: Partial<Omit<RateLimitError, "$typeName">> = {}): RateLimitError {
  return {
    $typeName: MessageKind.RateLimitError,
    ...data,
  } as RateLimitError;
}

export function createReadabilityMetrics(
  data: Partial<Omit<ReadabilityMetrics, "$typeName">> = {},
): ReadabilityMetrics {
  return {
    $typeName: MessageKind.ReadabilityMetrics,
    ...data,
  } as ReadabilityMetrics;
}

export function createRealm(data: Partial<Omit<Realm, "$typeName">> = {}): Realm {
  return {
    $typeName: MessageKind.Realm,
    ...data,
  } as Realm;
}

export function createRealmPermission(data: Partial<Omit<RealmPermission, "$typeName">> = {}): RealmPermission {
  return {
    $typeName: MessageKind.RealmPermission,
    ...data,
  } as RealmPermission;
}

export function createRealmPermissionGrant(
  data: Partial<Omit<RealmPermissionGrant, "$typeName">> = {},
): RealmPermissionGrant {
  return {
    $typeName: MessageKind.RealmPermissionGrant,
    ...data,
  } as RealmPermissionGrant;
}

export function createRealmUserPermissions(
  data: Partial<Omit<RealmUserPermissions, "$typeName">> = {},
): RealmUserPermissions {
  return {
    $typeName: MessageKind.RealmUserPermissions,
    ...data,
  } as RealmUserPermissions;
}

export function createRealmWithNames(data: Partial<Omit<RealmWithNames, "$typeName">> = {}): RealmWithNames {
  return {
    $typeName: MessageKind.RealmWithNames,
    ...data,
  } as RealmWithNames;
}

export function createRecordArtifactViewRequest(
  data: Partial<Omit<RecordArtifactViewRequest, "$typeName">> = {},
): RecordArtifactViewRequest {
  return {
    $typeName: MessageKind.RecordArtifactViewRequest,
    ...data,
  } as RecordArtifactViewRequest;
}

export function createRecordArtifactViewResponse(
  data: Partial<Omit<RecordArtifactViewResponse, "$typeName">> = {},
): RecordArtifactViewResponse {
  return {
    $typeName: MessageKind.RecordArtifactViewResponse,
    ...data,
  } as RecordArtifactViewResponse;
}

export function createRecordedMessage(data: Partial<Omit<RecordedMessage, "$typeName">> = {}): RecordedMessage {
  return {
    $typeName: MessageKind.RecordedMessage,
    ...data,
  } as RecordedMessage;
}

export function createRecording(data: Partial<Omit<Recording, "$typeName">> = {}): Recording {
  return {
    $typeName: MessageKind.Recording,
    ...data,
  } as Recording;
}

export function createReferenceMaterial(data: Partial<Omit<ReferenceMaterial, "$typeName">> = {}): ReferenceMaterial {
  return {
    $typeName: MessageKind.ReferenceMaterial,
    ...data,
  } as ReferenceMaterial;
}

export function createReferenceMaterial_Access(
  data: Partial<Omit<ReferenceMaterial_Access, "$typeName">> = {},
): ReferenceMaterial_Access {
  return {
    $typeName: MessageKind.ReferenceMaterial_Access,
    ...data,
  } as ReferenceMaterial_Access;
}

export function createReferenceMaterial_ContentSample(
  data: Partial<Omit<ReferenceMaterial_ContentSample, "$typeName">> = {},
): ReferenceMaterial_ContentSample {
  return {
    $typeName: MessageKind.ReferenceMaterial_ContentSample,
    ...data,
  } as ReferenceMaterial_ContentSample;
}

export function createReferenceMaterial_Relevance(
  data: Partial<Omit<ReferenceMaterial_Relevance, "$typeName">> = {},
): ReferenceMaterial_Relevance {
  return {
    $typeName: MessageKind.ReferenceMaterial_Relevance,
    ...data,
  } as ReferenceMaterial_Relevance;
}

export function createReferenceMaterial_Source(
  data: Partial<Omit<ReferenceMaterial_Source, "$typeName">> = {},
): ReferenceMaterial_Source {
  return {
    $typeName: MessageKind.ReferenceMaterial_Source,
    ...data,
  } as ReferenceMaterial_Source;
}

export function createReferenceRelationship(
  data: Partial<Omit<ReferenceRelationship, "$typeName">> = {},
): ReferenceRelationship {
  return {
    $typeName: MessageKind.ReferenceRelationship,
    ...data,
  } as ReferenceRelationship;
}

export function createRelatedArtifact(data: Partial<Omit<RelatedArtifact, "$typeName">> = {}): RelatedArtifact {
  return {
    $typeName: MessageKind.RelatedArtifact,
    ...data,
  } as RelatedArtifact;
}

export function createRelationshipData(data: Partial<Omit<RelationshipData, "$typeName">> = {}): RelationshipData {
  return {
    $typeName: MessageKind.RelationshipData,
    ...data,
  } as RelationshipData;
}

export function createReprocessAssetRequest(
  data: Partial<Omit<ReprocessAssetRequest, "$typeName">> = {},
): ReprocessAssetRequest {
  return {
    $typeName: MessageKind.ReprocessAssetRequest,
    ...data,
  } as ReprocessAssetRequest;
}

export function createReprocessAssetResponse(
  data: Partial<Omit<ReprocessAssetResponse, "$typeName">> = {},
): ReprocessAssetResponse {
  return {
    $typeName: MessageKind.ReprocessAssetResponse,
    ...data,
  } as ReprocessAssetResponse;
}

export function createRequestTooLargeError(
  data: Partial<Omit<RequestTooLargeError, "$typeName">> = {},
): RequestTooLargeError {
  return {
    $typeName: MessageKind.RequestTooLargeError,
    ...data,
  } as RequestTooLargeError;
}

export function createResourceAccess(data: Partial<Omit<ResourceAccess, "$typeName">> = {}): ResourceAccess {
  return {
    $typeName: MessageKind.ResourceAccess,
    ...data,
  } as ResourceAccess;
}

export function createResourceAttributeCondition(
  data: Partial<Omit<ResourceAttributeCondition, "$typeName">> = {},
): ResourceAttributeCondition {
  return {
    $typeName: MessageKind.ResourceAttributeCondition,
    ...data,
  } as ResourceAttributeCondition;
}

export function createResourceAttributeKeyPair(
  data: Partial<Omit<ResourceAttributeKeyPair, "$typeName">> = {},
): ResourceAttributeKeyPair {
  return {
    $typeName: MessageKind.ResourceAttributeKeyPair,
    ...data,
  } as ResourceAttributeKeyPair;
}

export function createResourceConstraints(
  data: Partial<Omit<ResourceConstraints, "$typeName">> = {},
): ResourceConstraints {
  return {
    $typeName: MessageKind.ResourceConstraints,
    ...data,
  } as ResourceConstraints;
}

export function createResourceLimit(data: Partial<Omit<ResourceLimit, "$typeName">> = {}): ResourceLimit {
  return {
    $typeName: MessageKind.ResourceLimit,
    ...data,
  } as ResourceLimit;
}

export function createResourceLimits(data: Partial<Omit<ResourceLimits, "$typeName">> = {}): ResourceLimits {
  return {
    $typeName: MessageKind.ResourceLimits,
    ...data,
  } as ResourceLimits;
}

export function createResourceReference(data: Partial<Omit<ResourceReference, "$typeName">> = {}): ResourceReference {
  return {
    $typeName: MessageKind.ResourceReference,
    ...data,
  } as ResourceReference;
}

export function createRestoreArtifactRequest(
  data: Partial<Omit<RestoreArtifactRequest, "$typeName">> = {},
): RestoreArtifactRequest {
  return {
    $typeName: MessageKind.RestoreArtifactRequest,
    ...data,
  } as RestoreArtifactRequest;
}

export function createRestoreArtifactResponse(
  data: Partial<Omit<RestoreArtifactResponse, "$typeName">> = {},
): RestoreArtifactResponse {
  return {
    $typeName: MessageKind.RestoreArtifactResponse,
    ...data,
  } as RestoreArtifactResponse;
}

export function createRetryStrategy(data: Partial<Omit<RetryStrategy, "$typeName">> = {}): RetryStrategy {
  return {
    $typeName: MessageKind.RetryStrategy,
    ...data,
  } as RetryStrategy;
}

export function createRevisionStatistics(
  data: Partial<Omit<RevisionStatistics, "$typeName">> = {},
): RevisionStatistics {
  return {
    $typeName: MessageKind.RevisionStatistics,
    ...data,
  } as RevisionStatistics;
}

export function createRevisionSummary(data: Partial<Omit<RevisionSummary, "$typeName">> = {}): RevisionSummary {
  return {
    $typeName: MessageKind.RevisionSummary,
    ...data,
  } as RevisionSummary;
}

export function createRevokeRealmPermissionsRequest(
  data: Partial<Omit<RevokeRealmPermissionsRequest, "$typeName">> = {},
): RevokeRealmPermissionsRequest {
  return {
    $typeName: MessageKind.RevokeRealmPermissionsRequest,
    ...data,
  } as RevokeRealmPermissionsRequest;
}

export function createRevokeRealmPermissionsResponse(
  data: Partial<Omit<RevokeRealmPermissionsResponse, "$typeName">> = {},
): RevokeRealmPermissionsResponse {
  return {
    $typeName: MessageKind.RevokeRealmPermissionsResponse,
    ...data,
  } as RevokeRealmPermissionsResponse;
}

export function createRichText(data: Partial<Omit<RichText, "$typeName">> = {}): RichText {
  return {
    $typeName: MessageKind.RichText,
    ...data,
  } as RichText;
}

export function createSEOMetadata(data: Partial<Omit<SEOMetadata, "$typeName">> = {}): SEOMetadata {
  return {
    $typeName: MessageKind.SEOMetadata,
    ...data,
  } as SEOMetadata;
}

export function createScope(data: Partial<Omit<Scope, "$typeName">> = {}): Scope {
  return {
    $typeName: MessageKind.Scope,
    ...data,
  } as Scope;
}

export function createScopeView(data: Partial<Omit<ScopeView, "$typeName">> = {}): ScopeView {
  return {
    $typeName: MessageKind.ScopeView,
    ...data,
  } as ScopeView;
}

export function createSearchArtifactsRequest(
  data: Partial<Omit<SearchArtifactsRequest, "$typeName">> = {},
): SearchArtifactsRequest {
  return {
    $typeName: MessageKind.SearchArtifactsRequest,
    ...data,
  } as SearchArtifactsRequest;
}

export function createSearchArtifactsResponse(
  data: Partial<Omit<SearchArtifactsResponse, "$typeName">> = {},
): SearchArtifactsResponse {
  return {
    $typeName: MessageKind.SearchArtifactsResponse,
    ...data,
  } as SearchArtifactsResponse;
}

export function createSearchAssetsRequest(
  data: Partial<Omit<SearchAssetsRequest, "$typeName">> = {},
): SearchAssetsRequest {
  return {
    $typeName: MessageKind.SearchAssetsRequest,
    ...data,
  } as SearchAssetsRequest;
}

export function createSearchAssetsResponse(
  data: Partial<Omit<SearchAssetsResponse, "$typeName">> = {},
): SearchAssetsResponse {
  return {
    $typeName: MessageKind.SearchAssetsResponse,
    ...data,
  } as SearchAssetsResponse;
}

export function createSearchFacet(data: Partial<Omit<SearchFacet, "$typeName">> = {}): SearchFacet {
  return {
    $typeName: MessageKind.SearchFacet,
    ...data,
  } as SearchFacet;
}

export function createSearchFacetValue(data: Partial<Omit<SearchFacetValue, "$typeName">> = {}): SearchFacetValue {
  return {
    $typeName: MessageKind.SearchFacetValue,
    ...data,
  } as SearchFacetValue;
}

export function createSearchHighlight(data: Partial<Omit<SearchHighlight, "$typeName">> = {}): SearchHighlight {
  return {
    $typeName: MessageKind.SearchHighlight,
    ...data,
  } as SearchHighlight;
}

export function createSearchMetadata(data: Partial<Omit<SearchMetadata, "$typeName">> = {}): SearchMetadata {
  return {
    $typeName: MessageKind.SearchMetadata,
    ...data,
  } as SearchMetadata;
}

export function createSearchOptions(data: Partial<Omit<SearchOptions, "$typeName">> = {}): SearchOptions {
  return {
    $typeName: MessageKind.SearchOptions,
    ...data,
  } as SearchOptions;
}

export function createSearchResult(data: Partial<Omit<SearchResult, "$typeName">> = {}): SearchResult {
  return {
    $typeName: MessageKind.SearchResult,
    ...data,
  } as SearchResult;
}

export function createSearchUsersRequest(
  data: Partial<Omit<SearchUsersRequest, "$typeName">> = {},
): SearchUsersRequest {
  return {
    $typeName: MessageKind.SearchUsersRequest,
    ...data,
  } as SearchUsersRequest;
}

export function createSearchUsersResponse(
  data: Partial<Omit<SearchUsersResponse, "$typeName">> = {},
): SearchUsersResponse {
  return {
    $typeName: MessageKind.SearchUsersResponse,
    ...data,
  } as SearchUsersResponse;
}

export function createServiceStatus(data: Partial<Omit<ServiceStatus, "$typeName">> = {}): ServiceStatus {
  return {
    $typeName: MessageKind.ServiceStatus,
    ...data,
  } as ServiceStatus;
}

export function createSettings(data: Partial<Omit<Settings, "$typeName">> = {}): Settings {
  return {
    $typeName: MessageKind.Settings,
    ...data,
  } as Settings;
}

export function createShare(data: Partial<Omit<Share, "$typeName">> = {}): Share {
  return {
    $typeName: MessageKind.Share,
    ...data,
  } as Share;
}

export function createSizeChange(data: Partial<Omit<SizeChange, "$typeName">> = {}): SizeChange {
  return {
    $typeName: MessageKind.SizeChange,
    ...data,
  } as SizeChange;
}

export function createSourceAccess(data: Partial<Omit<SourceAccess, "$typeName">> = {}): SourceAccess {
  return {
    $typeName: MessageKind.SourceAccess,
    ...data,
  } as SourceAccess;
}

export function createSourceAttribution(data: Partial<Omit<SourceAttribution, "$typeName">> = {}): SourceAttribution {
  return {
    $typeName: MessageKind.SourceAttribution,
    ...data,
  } as SourceAttribution;
}

export function createSourceAuthor(data: Partial<Omit<SourceAuthor, "$typeName">> = {}): SourceAuthor {
  return {
    $typeName: MessageKind.SourceAuthor,
    ...data,
  } as SourceAuthor;
}

export function createSourceCitation(data: Partial<Omit<SourceCitation, "$typeName">> = {}): SourceCitation {
  return {
    $typeName: MessageKind.SourceCitation,
    ...data,
  } as SourceCitation;
}

export function createSourceExcerpt(data: Partial<Omit<SourceExcerpt, "$typeName">> = {}): SourceExcerpt {
  return {
    $typeName: MessageKind.SourceExcerpt,
    ...data,
  } as SourceExcerpt;
}

export function createSourceMaterial(data: Partial<Omit<SourceMaterial, "$typeName">> = {}): SourceMaterial {
  return {
    $typeName: MessageKind.SourceMaterial,
    ...data,
  } as SourceMaterial;
}

export function createSourceMetadata(data: Partial<Omit<SourceMetadata, "$typeName">> = {}): SourceMetadata {
  return {
    $typeName: MessageKind.SourceMetadata,
    ...data,
  } as SourceMetadata;
}

export function createSourceQuality(data: Partial<Omit<SourceQuality, "$typeName">> = {}): SourceQuality {
  return {
    $typeName: MessageKind.SourceQuality,
    ...data,
  } as SourceQuality;
}

export function createSourceUsage(data: Partial<Omit<SourceUsage, "$typeName">> = {}): SourceUsage {
  return {
    $typeName: MessageKind.SourceUsage,
    ...data,
  } as SourceUsage;
}

export function createStatsPeriod(data: Partial<Omit<StatsPeriod, "$typeName">> = {}): StatsPeriod {
  return {
    $typeName: MessageKind.StatsPeriod,
    ...data,
  } as StatsPeriod;
}

export function createStepError(data: Partial<Omit<StepError, "$typeName">> = {}): StepError {
  return {
    $typeName: MessageKind.StepError,
    ...data,
  } as StepError;
}

export function createStrategyActivityInput(
  data: Partial<Omit<StrategyActivityInput, "$typeName">> = {},
): StrategyActivityInput {
  return {
    $typeName: MessageKind.StrategyActivityInput,
    ...data,
  } as StrategyActivityInput;
}

export function createStrategyActivityInput_StrategyOptions(
  data: Partial<Omit<StrategyActivityInput_StrategyOptions, "$typeName">> = {},
): StrategyActivityInput_StrategyOptions {
  return {
    $typeName: MessageKind.StrategyActivityInput_StrategyOptions,
    ...data,
  } as StrategyActivityInput_StrategyOptions;
}

export function createStrategyActivityOutput(
  data: Partial<Omit<StrategyActivityOutput, "$typeName">> = {},
): StrategyActivityOutput {
  return {
    $typeName: MessageKind.StrategyActivityOutput,
    ...data,
  } as StrategyActivityOutput;
}

export function createStrategyActivityOutput_StrategyMetadata(
  data: Partial<Omit<StrategyActivityOutput_StrategyMetadata, "$typeName">> = {},
): StrategyActivityOutput_StrategyMetadata {
  return {
    $typeName: MessageKind.StrategyActivityOutput_StrategyMetadata,
    ...data,
  } as StrategyActivityOutput_StrategyMetadata;
}

export function createStrategyActivityResult(
  data: Partial<Omit<StrategyActivityResult, "$typeName">> = {},
): StrategyActivityResult {
  return {
    $typeName: MessageKind.StrategyActivityResult,
    ...data,
  } as StrategyActivityResult;
}

export function createStrategyState(data: Partial<Omit<StrategyState, "$typeName">> = {}): StrategyState {
  return {
    $typeName: MessageKind.StrategyState,
    ...data,
  } as StrategyState;
}

export function createStreamPlaybackRequest(
  data: Partial<Omit<StreamPlaybackRequest, "$typeName">> = {},
): StreamPlaybackRequest {
  return {
    $typeName: MessageKind.StreamPlaybackRequest,
    ...data,
  } as StreamPlaybackRequest;
}

export function createStreamPlaybackResponse(
  data: Partial<Omit<StreamPlaybackResponse, "$typeName">> = {},
): StreamPlaybackResponse {
  return {
    $typeName: MessageKind.StreamPlaybackResponse,
    ...data,
  } as StreamPlaybackResponse;
}

export function createStreamRequest(data: Partial<Omit<StreamRequest, "$typeName">> = {}): StreamRequest {
  return {
    $typeName: MessageKind.StreamRequest,
    ...data,
  } as StreamRequest;
}

export function createStreamResponse(data: Partial<Omit<StreamResponse, "$typeName">> = {}): StreamResponse {
  return {
    $typeName: MessageKind.StreamResponse,
    ...data,
  } as StreamResponse;
}

export function createStrikeAttrs(data: Partial<Omit<StrikeAttrs, "$typeName">> = {}): StrikeAttrs {
  return {
    $typeName: MessageKind.StrikeAttrs,
    ...data,
  } as StrikeAttrs;
}

export function createStrongAttrs(data: Partial<Omit<StrongAttrs, "$typeName">> = {}): StrongAttrs {
  return {
    $typeName: MessageKind.StrongAttrs,
    ...data,
  } as StrongAttrs;
}

export function createSubscriptAttrs(data: Partial<Omit<SubscriptAttrs, "$typeName">> = {}): SubscriptAttrs {
  return {
    $typeName: MessageKind.SubscriptAttrs,
    ...data,
  } as SubscriptAttrs;
}

export function createSuperscriptAttrs(data: Partial<Omit<SuperscriptAttrs, "$typeName">> = {}): SuperscriptAttrs {
  return {
    $typeName: MessageKind.SuperscriptAttrs,
    ...data,
  } as SuperscriptAttrs;
}

export function createSyncRequest(data: Partial<Omit<SyncRequest, "$typeName">> = {}): SyncRequest {
  return {
    $typeName: MessageKind.SyncRequest,
    ...data,
  } as SyncRequest;
}

export function createSyncResponse(data: Partial<Omit<SyncResponse, "$typeName">> = {}): SyncResponse {
  return {
    $typeName: MessageKind.SyncResponse,
    ...data,
  } as SyncResponse;
}

export function createSystemPreference(data: Partial<Omit<SystemPreference, "$typeName">> = {}): SystemPreference {
  return {
    $typeName: MessageKind.SystemPreference,
    ...data,
  } as SystemPreference;
}

export function createTableAttrs(data: Partial<Omit<TableAttrs, "$typeName">> = {}): TableAttrs {
  return {
    $typeName: MessageKind.TableAttrs,
    ...data,
  } as TableAttrs;
}

export function createTableCellAttrs(data: Partial<Omit<TableCellAttrs, "$typeName">> = {}): TableCellAttrs {
  return {
    $typeName: MessageKind.TableCellAttrs,
    ...data,
  } as TableCellAttrs;
}

export function createTextAttachment(data: Partial<Omit<TextAttachment, "$typeName">> = {}): TextAttachment {
  return {
    $typeName: MessageKind.TextAttachment,
    ...data,
  } as TextAttachment;
}

export function createTimeConstraints(data: Partial<Omit<TimeConstraints, "$typeName">> = {}): TimeConstraints {
  return {
    $typeName: MessageKind.TimeConstraints,
    ...data,
  } as TimeConstraints;
}

export function createTimeLimit(data: Partial<Omit<TimeLimit, "$typeName">> = {}): TimeLimit {
  return {
    $typeName: MessageKind.TimeLimit,
    ...data,
  } as TimeLimit;
}

export function createToolConfig(data: Partial<Omit<ToolConfig, "$typeName">> = {}): ToolConfig {
  return {
    $typeName: MessageKind.ToolConfig,
    ...data,
  } as ToolConfig;
}

export function createToolError(data: Partial<Omit<ToolError, "$typeName">> = {}): ToolError {
  return {
    $typeName: MessageKind.ToolError,
    ...data,
  } as ToolError;
}

export function createToolExample(data: Partial<Omit<ToolExample, "$typeName">> = {}): ToolExample {
  return {
    $typeName: MessageKind.ToolExample,
    ...data,
  } as ToolExample;
}

export function createToolExecutionError(
  data: Partial<Omit<ToolExecutionError, "$typeName">> = {},
): ToolExecutionError {
  return {
    $typeName: MessageKind.ToolExecutionError,
    ...data,
  } as ToolExecutionError;
}

export function createToolParameter(data: Partial<Omit<ToolParameter, "$typeName">> = {}): ToolParameter {
  return {
    $typeName: MessageKind.ToolParameter,
    ...data,
  } as ToolParameter;
}

export function createToolParameters(data: Partial<Omit<ToolParameters, "$typeName">> = {}): ToolParameters {
  return {
    $typeName: MessageKind.ToolParameters,
    ...data,
  } as ToolParameters;
}

export function createToolProperty(data: Partial<Omit<ToolProperty, "$typeName">> = {}): ToolProperty {
  return {
    $typeName: MessageKind.ToolProperty,
    ...data,
  } as ToolProperty;
}

export function createToolSchema(data: Partial<Omit<ToolSchema, "$typeName">> = {}): ToolSchema {
  return {
    $typeName: MessageKind.ToolSchema,
    ...data,
  } as ToolSchema;
}

export function createToolSchemaShort(data: Partial<Omit<ToolSchemaShort, "$typeName">> = {}): ToolSchemaShort {
  return {
    $typeName: MessageKind.ToolSchemaShort,
    ...data,
  } as ToolSchemaShort;
}

export function createTriageActivityInput(
  data: Partial<Omit<TriageActivityInput, "$typeName">> = {},
): TriageActivityInput {
  return {
    $typeName: MessageKind.TriageActivityInput,
    ...data,
  } as TriageActivityInput;
}

export function createTriageActivityInput_TriageOptions(
  data: Partial<Omit<TriageActivityInput_TriageOptions, "$typeName">> = {},
): TriageActivityInput_TriageOptions {
  return {
    $typeName: MessageKind.TriageActivityInput_TriageOptions,
    ...data,
  } as TriageActivityInput_TriageOptions;
}

export function createTriageActivityOutput(
  data: Partial<Omit<TriageActivityOutput, "$typeName">> = {},
): TriageActivityOutput {
  return {
    $typeName: MessageKind.TriageActivityOutput,
    ...data,
  } as TriageActivityOutput;
}

export function createTriageActivityOutput_ClarificationRequest(
  data: Partial<Omit<TriageActivityOutput_ClarificationRequest, "$typeName">> = {},
): TriageActivityOutput_ClarificationRequest {
  return {
    $typeName: MessageKind.TriageActivityOutput_ClarificationRequest,
    ...data,
  } as TriageActivityOutput_ClarificationRequest;
}

export function createTriageActivityOutput_DirectResponse(
  data: Partial<Omit<TriageActivityOutput_DirectResponse, "$typeName">> = {},
): TriageActivityOutput_DirectResponse {
  return {
    $typeName: MessageKind.TriageActivityOutput_DirectResponse,
    ...data,
  } as TriageActivityOutput_DirectResponse;
}

export function createTriageActivityResult(
  data: Partial<Omit<TriageActivityResult, "$typeName">> = {},
): TriageActivityResult {
  return {
    $typeName: MessageKind.TriageActivityResult,
    ...data,
  } as TriageActivityResult;
}

export function createTriageState(data: Partial<Omit<TriageState, "$typeName">> = {}): TriageState {
  return {
    $typeName: MessageKind.TriageState,
    ...data,
  } as TriageState;
}

export function createUnpinViewRequest(data: Partial<Omit<UnpinViewRequest, "$typeName">> = {}): UnpinViewRequest {
  return {
    $typeName: MessageKind.UnpinViewRequest,
    ...data,
  } as UnpinViewRequest;
}

export function createUnpinViewResponse(data: Partial<Omit<UnpinViewResponse, "$typeName">> = {}): UnpinViewResponse {
  return {
    $typeName: MessageKind.UnpinViewResponse,
    ...data,
  } as UnpinViewResponse;
}

export function createUnpublishArtifactRequest(
  data: Partial<Omit<UnpublishArtifactRequest, "$typeName">> = {},
): UnpublishArtifactRequest {
  return {
    $typeName: MessageKind.UnpublishArtifactRequest,
    ...data,
  } as UnpublishArtifactRequest;
}

export function createUnpublishArtifactResponse(
  data: Partial<Omit<UnpublishArtifactResponse, "$typeName">> = {},
): UnpublishArtifactResponse {
  return {
    $typeName: MessageKind.UnpublishArtifactResponse,
    ...data,
  } as UnpublishArtifactResponse;
}

export function createUpdateArtifactContentRequest(
  data: Partial<Omit<UpdateArtifactContentRequest, "$typeName">> = {},
): UpdateArtifactContentRequest {
  return {
    $typeName: MessageKind.UpdateArtifactContentRequest,
    ...data,
  } as UpdateArtifactContentRequest;
}

export function createUpdateArtifactContentResponse(
  data: Partial<Omit<UpdateArtifactContentResponse, "$typeName">> = {},
): UpdateArtifactContentResponse {
  return {
    $typeName: MessageKind.UpdateArtifactContentResponse,
    ...data,
  } as UpdateArtifactContentResponse;
}

export function createUpdateArtifactRequest(
  data: Partial<Omit<UpdateArtifactRequest, "$typeName">> = {},
): UpdateArtifactRequest {
  return {
    $typeName: MessageKind.UpdateArtifactRequest,
    ...data,
  } as UpdateArtifactRequest;
}

export function createUpdateArtifactResponse(
  data: Partial<Omit<UpdateArtifactResponse, "$typeName">> = {},
): UpdateArtifactResponse {
  return {
    $typeName: MessageKind.UpdateArtifactResponse,
    ...data,
  } as UpdateArtifactResponse;
}

export function createUpdateAssetRequest(
  data: Partial<Omit<UpdateAssetRequest, "$typeName">> = {},
): UpdateAssetRequest {
  return {
    $typeName: MessageKind.UpdateAssetRequest,
    ...data,
  } as UpdateAssetRequest;
}

export function createUpdateAssetResponse(
  data: Partial<Omit<UpdateAssetResponse, "$typeName">> = {},
): UpdateAssetResponse {
  return {
    $typeName: MessageKind.UpdateAssetResponse,
    ...data,
  } as UpdateAssetResponse;
}

export function createUpdateAssetStatusRequest(
  data: Partial<Omit<UpdateAssetStatusRequest, "$typeName">> = {},
): UpdateAssetStatusRequest {
  return {
    $typeName: MessageKind.UpdateAssetStatusRequest,
    ...data,
  } as UpdateAssetStatusRequest;
}

export function createUpdateAssetStatusResponse(
  data: Partial<Omit<UpdateAssetStatusResponse, "$typeName">> = {},
): UpdateAssetStatusResponse {
  return {
    $typeName: MessageKind.UpdateAssetStatusResponse,
    ...data,
  } as UpdateAssetStatusResponse;
}

export function createUpdateLabelRequest(
  data: Partial<Omit<UpdateLabelRequest, "$typeName">> = {},
): UpdateLabelRequest {
  return {
    $typeName: MessageKind.UpdateLabelRequest,
    ...data,
  } as UpdateLabelRequest;
}

export function createUpdateLabelResponse(
  data: Partial<Omit<UpdateLabelResponse, "$typeName">> = {},
): UpdateLabelResponse {
  return {
    $typeName: MessageKind.UpdateLabelResponse,
    ...data,
  } as UpdateLabelResponse;
}

export function createUpdateLastAccessedRequest(
  data: Partial<Omit<UpdateLastAccessedRequest, "$typeName">> = {},
): UpdateLastAccessedRequest {
  return {
    $typeName: MessageKind.UpdateLastAccessedRequest,
    ...data,
  } as UpdateLastAccessedRequest;
}

export function createUpdateLastAccessedResponse(
  data: Partial<Omit<UpdateLastAccessedResponse, "$typeName">> = {},
): UpdateLastAccessedResponse {
  return {
    $typeName: MessageKind.UpdateLastAccessedResponse,
    ...data,
  } as UpdateLastAccessedResponse;
}

export function createUpdateProcessingProgressRequest(
  data: Partial<Omit<UpdateProcessingProgressRequest, "$typeName">> = {},
): UpdateProcessingProgressRequest {
  return {
    $typeName: MessageKind.UpdateProcessingProgressRequest,
    ...data,
  } as UpdateProcessingProgressRequest;
}

export function createUpdateProcessingProgressResponse(
  data: Partial<Omit<UpdateProcessingProgressResponse, "$typeName">> = {},
): UpdateProcessingProgressResponse {
  return {
    $typeName: MessageKind.UpdateProcessingProgressResponse,
    ...data,
  } as UpdateProcessingProgressResponse;
}

export function createUpdateRealmNamesRequest(
  data: Partial<Omit<UpdateRealmNamesRequest, "$typeName">> = {},
): UpdateRealmNamesRequest {
  return {
    $typeName: MessageKind.UpdateRealmNamesRequest,
    ...data,
  } as UpdateRealmNamesRequest;
}

export function createUpdateRealmNamesResponse(
  data: Partial<Omit<UpdateRealmNamesResponse, "$typeName">> = {},
): UpdateRealmNamesResponse {
  return {
    $typeName: MessageKind.UpdateRealmNamesResponse,
    ...data,
  } as UpdateRealmNamesResponse;
}

export function createUpdateSelfRequest(data: Partial<Omit<UpdateSelfRequest, "$typeName">> = {}): UpdateSelfRequest {
  return {
    $typeName: MessageKind.UpdateSelfRequest,
    ...data,
  } as UpdateSelfRequest;
}

export function createUpdateSelfResponse(
  data: Partial<Omit<UpdateSelfResponse, "$typeName">> = {},
): UpdateSelfResponse {
  return {
    $typeName: MessageKind.UpdateSelfResponse,
    ...data,
  } as UpdateSelfResponse;
}

export function createUpdateViewRequest(data: Partial<Omit<UpdateViewRequest, "$typeName">> = {}): UpdateViewRequest {
  return {
    $typeName: MessageKind.UpdateViewRequest,
    ...data,
  } as UpdateViewRequest;
}

export function createUpdateViewResponse(
  data: Partial<Omit<UpdateViewResponse, "$typeName">> = {},
): UpdateViewResponse {
  return {
    $typeName: MessageKind.UpdateViewResponse,
    ...data,
  } as UpdateViewResponse;
}

export function createUploadAssetRequest(
  data: Partial<Omit<UploadAssetRequest, "$typeName">> = {},
): UploadAssetRequest {
  return {
    $typeName: MessageKind.UploadAssetRequest,
    ...data,
  } as UploadAssetRequest;
}

export function createUploadAssetResponse(
  data: Partial<Omit<UploadAssetResponse, "$typeName">> = {},
): UploadAssetResponse {
  return {
    $typeName: MessageKind.UploadAssetResponse,
    ...data,
  } as UploadAssetResponse;
}

export function createUploadProgress(data: Partial<Omit<UploadProgress, "$typeName">> = {}): UploadProgress {
  return {
    $typeName: MessageKind.UploadProgress,
    ...data,
  } as UploadProgress;
}

export function createUser(data: Partial<Omit<User, "$typeName">> = {}): User {
  return {
    $typeName: MessageKind.User,
    ...data,
  } as User;
}

export function createUserAttribution(data: Partial<Omit<UserAttribution, "$typeName">> = {}): UserAttribution {
  return {
    $typeName: MessageKind.UserAttribution,
    ...data,
  } as UserAttribution;
}

export function createUserData(data: Partial<Omit<UserData, "$typeName">> = {}): UserData {
  return {
    $typeName: MessageKind.UserData,
    ...data,
  } as UserData;
}

export function createUserInternal(data: Partial<Omit<UserInternal, "$typeName">> = {}): UserInternal {
  return {
    $typeName: MessageKind.UserInternal,
    ...data,
  } as UserInternal;
}

export function createUserKbSearchInput(data: Partial<Omit<UserKbSearchInput, "$typeName">> = {}): UserKbSearchInput {
  return {
    $typeName: MessageKind.UserKbSearchInput,
    ...data,
  } as UserKbSearchInput;
}

export function createUserKbSearchOutput(
  data: Partial<Omit<UserKbSearchOutput, "$typeName">> = {},
): UserKbSearchOutput {
  return {
    $typeName: MessageKind.UserKbSearchOutput,
    ...data,
  } as UserKbSearchOutput;
}

export function createUserKbSearchResult(
  data: Partial<Omit<UserKbSearchResult, "$typeName">> = {},
): UserKbSearchResult {
  return {
    $typeName: MessageKind.UserKbSearchResult,
    ...data,
  } as UserKbSearchResult;
}

export function createUserLearning(data: Partial<Omit<UserLearning, "$typeName">> = {}): UserLearning {
  return {
    $typeName: MessageKind.UserLearning,
    ...data,
  } as UserLearning;
}

export function createUserLearning_LearningContent(
  data: Partial<Omit<UserLearning_LearningContent, "$typeName">> = {},
): UserLearning_LearningContent {
  return {
    $typeName: MessageKind.UserLearning_LearningContent,
    ...data,
  } as UserLearning_LearningContent;
}

export function createUserLearning_LearningMetadata(
  data: Partial<Omit<UserLearning_LearningMetadata, "$typeName">> = {},
): UserLearning_LearningMetadata {
  return {
    $typeName: MessageKind.UserLearning_LearningMetadata,
    ...data,
  } as UserLearning_LearningMetadata;
}

export function createUserMemory(data: Partial<Omit<UserMemory, "$typeName">> = {}): UserMemory {
  return {
    $typeName: MessageKind.UserMemory,
    ...data,
  } as UserMemory;
}

export function createUserMemory_MemoryContent(
  data: Partial<Omit<UserMemory_MemoryContent, "$typeName">> = {},
): UserMemory_MemoryContent {
  return {
    $typeName: MessageKind.UserMemory_MemoryContent,
    ...data,
  } as UserMemory_MemoryContent;
}

export function createUserMemory_MemoryMetadata(
  data: Partial<Omit<UserMemory_MemoryMetadata, "$typeName">> = {},
): UserMemory_MemoryMetadata {
  return {
    $typeName: MessageKind.UserMemory_MemoryMetadata,
    ...data,
  } as UserMemory_MemoryMetadata;
}

export function createUserWithActions(data: Partial<Omit<UserWithActions, "$typeName">> = {}): UserWithActions {
  return {
    $typeName: MessageKind.UserWithActions,
    ...data,
  } as UserWithActions;
}

export function createValidationRequirements(
  data: Partial<Omit<ValidationRequirements, "$typeName">> = {},
): ValidationRequirements {
  return {
    $typeName: MessageKind.ValidationRequirements,
    ...data,
  } as ValidationRequirements;
}

export function createVariableNodeV1Attrs(
  data: Partial<Omit<VariableNodeV1Attrs, "$typeName">> = {},
): VariableNodeV1Attrs {
  return {
    $typeName: MessageKind.VariableNodeV1Attrs,
    ...data,
  } as VariableNodeV1Attrs;
}

export function createVersionApproval(data: Partial<Omit<VersionApproval, "$typeName">> = {}): VersionApproval {
  return {
    $typeName: MessageKind.VersionApproval,
    ...data,
  } as VersionApproval;
}

export function createVersionApprovalRecord(
  data: Partial<Omit<VersionApprovalRecord, "$typeName">> = {},
): VersionApprovalRecord {
  return {
    $typeName: MessageKind.VersionApprovalRecord,
    ...data,
  } as VersionApprovalRecord;
}

export function createVersionChange(data: Partial<Omit<VersionChange, "$typeName">> = {}): VersionChange {
  return {
    $typeName: MessageKind.VersionChange,
    ...data,
  } as VersionChange;
}

export function createVersionComparison(data: Partial<Omit<VersionComparison, "$typeName">> = {}): VersionComparison {
  return {
    $typeName: MessageKind.VersionComparison,
    ...data,
  } as VersionComparison;
}

export function createVersionDifference(data: Partial<Omit<VersionDifference, "$typeName">> = {}): VersionDifference {
  return {
    $typeName: MessageKind.VersionDifference,
    ...data,
  } as VersionDifference;
}

export function createVersionQualityMetrics(
  data: Partial<Omit<VersionQualityMetrics, "$typeName">> = {},
): VersionQualityMetrics {
  return {
    $typeName: MessageKind.VersionQualityMetrics,
    ...data,
  } as VersionQualityMetrics;
}

export function createVersionSizeInfo(data: Partial<Omit<VersionSizeInfo, "$typeName">> = {}): VersionSizeInfo {
  return {
    $typeName: MessageKind.VersionSizeInfo,
    ...data,
  } as VersionSizeInfo;
}

export function createView(data: Partial<Omit<View, "$typeName">> = {}): View {
  return {
    $typeName: MessageKind.View,
    ...data,
  } as View;
}

export function createViewFilter(data: Partial<Omit<ViewFilter, "$typeName">> = {}): ViewFilter {
  return {
    $typeName: MessageKind.ViewFilter,
    ...data,
  } as ViewFilter;
}

export function createViewResultItem(data: Partial<Omit<ViewResultItem, "$typeName">> = {}): ViewResultItem {
  return {
    $typeName: MessageKind.ViewResultItem,
    ...data,
  } as ViewResultItem;
}

export function createViewResults(data: Partial<Omit<ViewResults, "$typeName">> = {}): ViewResults {
  return {
    $typeName: MessageKind.ViewResults,
    ...data,
  } as ViewResults;
}

export function createViewSummary(data: Partial<Omit<ViewSummary, "$typeName">> = {}): ViewSummary {
  return {
    $typeName: MessageKind.ViewSummary,
    ...data,
  } as ViewSummary;
}

export function createViewWithActions(data: Partial<Omit<ViewWithActions, "$typeName">> = {}): ViewWithActions {
  return {
    $typeName: MessageKind.ViewWithActions,
    ...data,
  } as ViewWithActions;
}

export function createWebSearchToolInput(
  data: Partial<Omit<WebSearchToolInput, "$typeName">> = {},
): WebSearchToolInput {
  return {
    $typeName: MessageKind.WebSearchToolInput,
    ...data,
  } as WebSearchToolInput;
}

export function createWebSearchToolOutput(
  data: Partial<Omit<WebSearchToolOutput, "$typeName">> = {},
): WebSearchToolOutput {
  return {
    $typeName: MessageKind.WebSearchToolOutput,
    ...data,
  } as WebSearchToolOutput;
}

export function createWorkflowConstraints(
  data: Partial<Omit<WorkflowConstraints, "$typeName">> = {},
): WorkflowConstraints {
  return {
    $typeName: MessageKind.WorkflowConstraints,
    ...data,
  } as WorkflowConstraints;
}

export function createWorkflowContext(data: Partial<Omit<WorkflowContext, "$typeName">> = {}): WorkflowContext {
  return {
    $typeName: MessageKind.WorkflowContext,
    ...data,
  } as WorkflowContext;
}

export function createWorkflowError(data: Partial<Omit<WorkflowError, "$typeName">> = {}): WorkflowError {
  return {
    $typeName: MessageKind.WorkflowError,
    ...data,
  } as WorkflowError;
}

export function createWorkflowLimit(data: Partial<Omit<WorkflowLimit, "$typeName">> = {}): WorkflowLimit {
  return {
    $typeName: MessageKind.WorkflowLimit,
    ...data,
  } as WorkflowLimit;
}
